import { useTheme } from '@emotion/react';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import {
  Box,
  Button,
  Card,
  Dialog,
  Divider,
  FormControlLabel,
  Grid,
  InputAdornment,
  InputBase,
  List,
  ListItem,
  ListItemText,
  MenuItem,
  Select,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
  Typography,
  useMediaQuery,
} from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import FormControl from '@mui/material/FormControl';
import IconButton from '@mui/material/IconButton';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Skeleton from '@mui/material/Skeleton';
import { fontFamily, Stack } from '@mui/system';
import Avatar from 'antd/es/avatar/avatar';
import {
  buyerCheckIn,
  getApiCall,
  Moxoseparationinlisting,
  postApiCall,
} from 'api/apiService';
import Dp from 'assets/dummy/buy.jpg';
import buyerRegistration from 'assets/icons/buyerregistration.svg';
import dashboardLogo from 'assets/icons/retrexlogo.png';
import mailicon from 'assets/images/mailicon.png';
import qr from 'assets/images/QR.png';
import { ReactComponent as Category } from 'assets/svg/Category.svg';
import searchIcon from 'assets/svg/searchIcon.svg';
import {
  BuyerCheckLbl,
  displayFlex,
} from 'component/ActivityContainer/ActivityContainer.style';
import CardHeaderContainer from 'component/CardHeaderContainer/CardHeaderContainer';
import { ToggleOff } from 'component/ContactTab/ContactTab';
import { Footerelements } from 'component/Footer';
import {
  AirbnbSlider,
  AirbnbThumbComponent,
} from 'component/PropertyCreation/CustomizedSlider';
import QRCodeScannerComponent from 'component/QrCodeScanner/QrCodeScanner';
import { QuickSwitch } from 'component/QuickSwitch/QuickSwitch';
import {
  BUYER_CHECK_IN,
  PROPERTYLIST_COMMON,
  SIGNUP_URL,
} from 'constant/app.config';
import React, { useEffect, useRef, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import { poppins400, poppins500, poppins600 } from 'theme/common.style';
import { validateEmail } from 'utils/validation.util';
import { statusCard } from './BuyerRegistration.style';
import { ReactComponent as Propertymenu } from 'assets/svg/propertymenu.svg';
import EnhancedTable from './Table';
import TableAccordion from './TableAccordion';
import { Cancelicon } from 'assets/svgfunctions/commonsvg';
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import Loading from 'assets/images/loading.png';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ScaledDialogContent from 'component/Common/ScaledDialogContent';
import BuyerCheckInCard from './BuyerCheckInCard';

const headCells = [
  {
    id: 'name',
    numeric: false,
    disablePadding: true,
    label: 'Name',
  },
  {
    id: 'contact',
    numeric: true,
    disablePadding: false,
    label: 'Contact',
  },
  {
    id: 'buyerreadlines',
    numeric: true,
    disablePadding: false,
    label: 'Buyer Readlines',
  },
  {
    id: 'status',
    numeric: true,
    disablePadding: false,
    label: 'Status',
  },
  {
    id: 'offer',
    numeric: true,
    disablePadding: false,
    label: 'Offer',
  },
  {
    id: 'noofoffer',
    numeric: true,
    disablePadding: false,
    label: 'Number of offers',
  },
  {
    id: 'propertyrating',
    numeric: true,
    disablePadding: false,
    label: 'Property Rating',
  },
  {
    id: 'exp',
    numeric: true,
    disablePadding: false,
    label: 'Exp',
  },
  {
    id: 'profile',
    numeric: true,
    disablePadding: false,
    label: 'Profile',
  },
  {
    id: 'profile',
    numeric: true,
    disablePadding: false,
    label: '',
  },
  {
    id: 'action',
    numeric: true,
    disablePadding: false,
    label: 'Action Required',
  },
];
const headCellsvendor = [
  {
    id: 'name',
    numeric: false,
    disablePadding: true,
    label: 'Name',
  },
  {
    id: 'offer',
    numeric: true,
    disablePadding: false,
    label: 'Offer',
  },
  {
    id: 'noofoffer',
    numeric: true,
    disablePadding: false,
    label: 'Number of offers',
  },
  {
    id: 'propertyrating',
    numeric: true,
    disablePadding: false,
    label: 'Property Rating',
  },
  {
    id: 'exp',
    numeric: true,
    disablePadding: false,
    label: 'Exp',
  },
  {
    id: 'profile',
    numeric: true,
    disablePadding: false,
    label: 'Profile',
  },
  {
    id: 'profile',
    numeric: true,
    disablePadding: false,
    label: '',
  },
  {
    id: 'action',
    numeric: true,
    disablePadding: false,
    label: 'Action Required',
  },
];
const Sorticon = () => {
  return (
    <svg
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.002 25.1777L16.8192 27.506V11.6795C16.8192 11.4102 16.7189 11.1519 16.5404 10.9615C16.3618 10.771 16.1197 10.6641 15.8672 10.6641C15.6148 10.6641 15.3726 10.771 15.1941 10.9615C15.0156 11.1519 14.9153 11.4102 14.9153 11.6795V27.506L12.7324 25.1777C12.5529 24.9927 12.3124 24.8904 12.0628 24.8927C11.8132 24.895 11.5745 25.0018 11.398 25.1901C11.2215 25.3783 11.1213 25.633 11.1192 25.8993C11.117 26.1655 11.213 26.422 11.3864 26.6135L15.1942 30.6753C15.3729 30.8653 15.6149 30.9721 15.8673 30.9721C16.1196 30.9721 16.3617 30.8653 16.5404 30.6753L20.3482 26.6135C20.5222 26.4221 20.6187 26.1654 20.6168 25.8988C20.6149 25.6321 20.5148 25.377 20.338 25.1885C20.1612 25 19.9221 24.8931 19.6721 24.8911C19.4221 24.8891 19.1815 24.992 19.002 25.1777Z"
        fill="#666666"
      />
      <path
        d="M19.6746 14.7262H29.1942C29.4467 14.7262 29.6888 14.6192 29.8673 14.4288C30.0459 14.2383 30.1462 13.9801 30.1462 13.7107C30.1462 13.4414 30.0459 13.1832 29.8673 12.9927C29.6888 12.8023 29.4467 12.6953 29.1942 12.6953H19.6746C19.4221 12.6953 19.18 12.8023 19.0015 12.9927C18.823 13.1832 18.7227 13.4414 18.7227 13.7107C18.7227 13.9801 18.823 14.2383 19.0015 14.4288C19.18 14.6192 19.4221 14.7262 19.6746 14.7262Z"
        fill="#666666"
      />
      <path
        d="M29.1942 16.7578H19.6746C19.4221 16.7578 19.18 16.8648 19.0015 17.0552C18.823 17.2457 18.7227 17.5039 18.7227 17.7732C18.7227 18.0426 18.823 18.3008 19.0015 18.4913C19.18 18.6817 19.4221 18.7887 19.6746 18.7887H29.1942C29.4467 18.7887 29.6888 18.6817 29.8673 18.4913C30.0459 18.3008 30.1462 18.0426 30.1462 17.7732C30.1462 17.5039 30.0459 17.2457 29.8673 17.0552C29.6888 16.8648 29.4467 16.7578 29.1942 16.7578Z"
        fill="#666666"
      />
      <path
        d="M26.3383 20.8184H19.6746C19.4221 20.8184 19.18 20.9253 19.0015 21.1158C18.823 21.3062 18.7227 21.5645 18.7227 21.8338C18.7227 22.1031 18.823 22.3614 19.0015 22.5518C19.18 22.7422 19.4221 22.8492 19.6746 22.8492H26.3383C26.5908 22.8492 26.8329 22.7422 27.0115 22.5518C27.19 22.3614 27.2903 22.1031 27.2903 21.8338C27.2903 21.5645 27.19 21.3062 27.0115 21.1158C26.8329 20.9253 26.5908 20.8184 26.3383 20.8184Z"
        fill="#666666"
      />
      <rect
        opacity="0.1"
        x="0.704102"
        y="1.13281"
        width="40"
        height="40"
        rx="4.5"
        stroke="#112347"
      />
    </svg>
  );
};
const Sortcoloricon = () => {
  return (
    <svg
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.002 25.1777L16.8192 27.506V11.6795C16.8192 11.4102 16.7189 11.1519 16.5404 10.9615C16.3618 10.771 16.1197 10.6641 15.8672 10.6641C15.6148 10.6641 15.3726 10.771 15.1941 10.9615C15.0156 11.1519 14.9153 11.4102 14.9153 11.6795V27.506L12.7324 25.1777C12.5529 24.9927 12.3124 24.8904 12.0628 24.8927C11.8132 24.895 11.5745 25.0018 11.398 25.1901C11.2215 25.3783 11.1213 25.633 11.1192 25.8993C11.117 26.1655 11.213 26.422 11.3864 26.6135L15.1942 30.6753C15.3729 30.8653 15.6149 30.9721 15.8673 30.9721C16.1196 30.9721 16.3617 30.8653 16.5404 30.6753L20.3482 26.6135C20.5222 26.4221 20.6187 26.1654 20.6168 25.8988C20.6149 25.6321 20.5148 25.377 20.338 25.1885C20.1612 25 19.9221 24.8931 19.6721 24.8911C19.4221 24.8891 19.1815 24.992 19.002 25.1777Z"
        fill="#0065FC"
      />
      <path
        d="M19.6746 14.7262H29.1942C29.4467 14.7262 29.6888 14.6192 29.8673 14.4288C30.0459 14.2383 30.1462 13.9801 30.1462 13.7107C30.1462 13.4414 30.0459 13.1832 29.8673 12.9927C29.6888 12.8023 29.4467 12.6953 29.1942 12.6953H19.6746C19.4221 12.6953 19.18 12.8023 19.0015 12.9927C18.823 13.1832 18.7227 13.4414 18.7227 13.7107C18.7227 13.9801 18.823 14.2383 19.0015 14.4288C19.18 14.6192 19.4221 14.7262 19.6746 14.7262Z"
        fill="#0065FC"
      />
      <path
        d="M29.1942 16.7578H19.6746C19.4221 16.7578 19.18 16.8648 19.0015 17.0552C18.823 17.2457 18.7227 17.5039 18.7227 17.7732C18.7227 18.0426 18.823 18.3008 19.0015 18.4913C19.18 18.6817 19.4221 18.7887 19.6746 18.7887H29.1942C29.4467 18.7887 29.6888 18.6817 29.8673 18.4913C30.0459 18.3008 30.1462 18.0426 30.1462 17.7732C30.1462 17.5039 30.0459 17.2457 29.8673 17.0552C29.6888 16.8648 29.4467 16.7578 29.1942 16.7578Z"
        fill="#0065FC"
      />
      <path
        d="M26.3383 20.8184H19.6746C19.4221 20.8184 19.18 20.9253 19.0015 21.1158C18.823 21.3062 18.7227 21.5645 18.7227 21.8338C18.7227 22.1031 18.823 22.3614 19.0015 22.5518C19.18 22.7422 19.4221 22.8492 19.6746 22.8492H26.3383C26.5908 22.8492 26.8329 22.7422 27.0115 22.5518C27.19 22.3614 27.2903 22.1031 27.2903 21.8338C27.2903 21.5645 27.19 21.3062 27.0115 21.1158C26.8329 20.9253 26.5908 20.8184 26.3383 20.8184Z"
        fill="#0065FC"
      />
      <rect
        opacity="1"
        x="0.704102"
        y="1.13281"
        width="40"
        height="40"
        rx="4.5"
        stroke="#F0F0F0"
      />
    </svg>
  );
};

const SearchIcons = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.24576 0.121094C3.26453 0.121094 0.0371094 3.27724 0.0371094 7.17054C0.0371094 11.0638 3.26453 14.22 7.24576 14.22C8.94852 14.22 10.5134 13.6426 11.7468 12.6772L14.0899 14.9626L14.1522 15.0151C14.3698 15.1725 14.6782 15.1546 14.875 14.9616C15.0915 14.7493 15.0911 14.4055 14.874 14.1938L12.5585 11.9353C13.7358 10.6806 14.4544 9.00765 14.4544 7.17054C14.4544 3.27724 11.227 0.121094 7.24576 0.121094ZM7.24577 1.2069C10.6138 1.2069 13.3441 3.87691 13.3441 7.17054C13.3441 10.4642 10.6138 13.1342 7.24577 13.1342C3.87775 13.1342 1.14744 10.4642 1.14744 7.17054C1.14744 3.87691 3.87775 1.2069 7.24577 1.2069Z"
        fill="#666666"
      />
    </svg>
  );
};
const AddbuyerPlusIcon = () => {
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.5 0.5C6.69891 0.5 6.88968 0.579018 7.03033 0.71967C7.17098 0.860322 7.25 1.05109 7.25 1.25V5.75H11.75C11.9489 5.75 12.1397 5.82902 12.2803 5.96967C12.421 6.11032 12.5 6.30109 12.5 6.5C12.5 6.69891 12.421 6.88968 12.2803 7.03033C12.1397 7.17098 11.9489 7.25 11.75 7.25H7.25V11.75C7.25 11.9489 7.17098 12.1397 7.03033 12.2803C6.88968 12.421 6.69891 12.5 6.5 12.5C6.30109 12.5 6.11032 12.421 5.96967 12.2803C5.82902 12.1397 5.75 11.9489 5.75 11.75V7.25H1.25C1.05109 7.25 0.860322 7.17098 0.71967 7.03033C0.579018 6.88968 0.5 6.69891 0.5 6.5C0.5 6.30109 0.579018 6.11032 0.71967 5.96967C0.860322 5.82902 1.05109 5.75 1.25 5.75H5.75V1.25C5.75 1.05109 5.82902 0.860322 5.96967 0.71967C6.11032 0.579018 6.30109 0.5 6.5 0.5Z"
        fill="#666666"
      />
    </svg>
  );
};

const SortUpcoloricon = () => {
  return (
    <svg
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="rotate(180, 16, 21)">
        <path
          d="M19.002 25.1777L16.8192 27.506V11.6795C16.8192 11.4102 16.7189 11.1519 16.5404 10.9615C16.3618 10.771 16.1197 10.6641 15.8672 10.6641C15.6148 10.6641 15.3726 10.771 15.1941 10.9615C15.0156 11.1519 14.9153 11.4102 14.9153 11.6795V27.506L12.7324 25.1777C12.5529 24.9927 12.3124 24.8904 12.0628 24.8927C11.8132 24.895 11.5745 25.0018 11.398 25.1901C11.2215 25.3783 11.1213 25.633 11.1192 25.8993C11.117 26.1655 11.213 26.422 11.3864 26.6135L15.1942 30.6753C15.3729 30.8653 15.6149 30.9721 15.8673 30.9721C16.1196 30.9721 16.3617 30.8653 16.5404 30.6753L20.3482 26.6135C20.5222 26.4221 20.6187 26.1654 20.6168 25.8988C20.6149 25.6321 20.5148 25.377 20.338 25.1885C20.1612 25 19.9221 24.8931 19.6721 24.8911C19.4221 24.8891 19.1815 24.992 19.002 25.1777Z"
          fill="#0065FC"
        />
        <g transform="scale(-1, 1) translate(-31, 0)">
          <path
            d="M19.6746 14.7262H29.1942C29.4467 14.7262 29.6888 14.6192 29.8673 14.4288C30.0459 14.2383 30.1462 13.9801 30.1462 13.7107C30.1462 13.4414 30.0459 13.1832 29.8673 12.9927C29.6888 12.8023 29.4467 12.6953 29.1942 12.6953H19.6746C19.4221 12.6953 19.18 12.8023 19.0015 12.9927C18.823 13.1832 18.7227 13.4414 18.7227 13.7107C18.7227 13.9801 18.823 14.2383 19.0015 14.4288C19.18 14.6192 19.4221 14.7262 19.6746 14.7262Z"
            fill="#0065FC"
          />
          <path
            d="M29.1942 16.7578H19.6746C19.4221 16.7578 19.18 16.8648 19.0015 17.0552C18.823 17.2457 18.7227 17.5039 18.7227 17.7732C18.7227 18.0426 18.823 18.3008 19.0015 18.4913C19.18 18.6817 19.4221 18.7887 19.6746 18.7887H29.1942C29.4467 18.7887 29.6888 18.6817 29.8673 18.4913C30.0459 18.3008 30.1462 18.0426 30.1462 17.7732C30.1462 17.5039 30.0459 17.2457 29.8673 17.0552C29.6888 16.8648 29.4467 16.7578 29.1942 16.7578Z"
            fill="#0065FC"
          />
          <path
            d="M26.3383 20.8184H19.6746C19.4221 20.8184 19.18 20.9253 19.0015 21.1158C18.823 21.3062 18.7227 21.5645 18.7227 21.8338C18.7227 22.1031 18.823 22.3614 19.0015 22.5518C19.18 22.7422 19.4221 22.8492 19.6746 22.8492H26.3383C26.5908 22.8492 26.8329 22.7422 27.0115 22.5518C27.19 22.3614 27.2903 22.1031 27.2903 21.8338C27.2903 21.5645 27.19 21.3062 27.0115 21.1158C26.8329 20.9253 26.5908 20.8184 26.3383 20.8184Z"
            fill="#0065FC"
          />
        </g>
      </g>
      <rect
        opacity="0.1"
        x="0.704102"
        y="1.13281"
        width="40"
        height="40"
        rx="4.5"
        stroke="#112347"
      />
    </svg>
  );
};

const Filtericon = () => {
  return (
    <svg
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.7104 13.651C16.7104 12.5087 15.729 11.5787 14.5207 11.5787C13.3136 11.5787 12.3309 12.5087 12.3309 13.651C12.3309 14.7933 13.3136 15.7233 14.5207 15.7233C15.729 15.7233 16.7104 14.7933 16.7104 13.651ZM18.6449 13.651C18.6449 15.8026 16.7956 17.554 14.5207 17.554C12.2471 17.554 10.3965 15.8026 10.3965 13.651C10.3965 11.4994 12.2471 9.74805 14.5207 9.74805C16.7956 9.74805 18.6449 11.4994 18.6449 13.651ZM32.3204 13.6512C32.3204 13.146 31.8871 12.7359 31.3532 12.7359H23.422C22.8881 12.7359 22.4548 13.146 22.4548 13.6512C22.4548 14.1565 22.8881 14.5666 23.422 14.5666H31.3532C31.8871 14.5666 32.3204 14.1565 32.3204 13.6512ZM26.006 25.813C26.006 26.9553 26.9874 27.8853 28.1958 27.8853C29.4042 27.8853 30.3856 26.9553 30.3856 25.813C30.3856 24.6695 29.4042 23.7407 28.1958 23.7407C26.9874 23.7407 26.006 24.6695 26.006 25.813ZM24.0716 25.813C24.0716 23.6602 25.9209 21.9101 28.1958 21.9101C30.4707 21.9101 32.32 23.6602 32.32 25.813C32.32 27.9646 30.4707 29.716 28.1958 29.716C25.9209 29.716 24.0716 27.9646 24.0716 25.813ZM11.3646 24.8973H19.2945C19.8284 24.8973 20.2617 25.3074 20.2617 25.8127C20.2617 26.3179 19.8284 26.728 19.2945 26.728H11.3646C10.8307 26.728 10.3974 26.3179 10.3974 25.8127C10.3974 25.3074 10.8307 24.8973 11.3646 24.8973Z"
        fill="#666666"
      />
      <rect
        opacity="0.1"
        x="0.704102"
        y="0.621094"
        width="40"
        height="40"
        rx="4.5"
        stroke="#112347"
      />
    </svg>
  );
};

const Filtercoloricon = () => {
  return (
    <svg
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.7104 13.651C16.7104 12.5087 15.729 11.5787 14.5207 11.5787C13.3136 11.5787 12.3309 12.5087 12.3309 13.651C12.3309 14.7933 13.3136 15.7233 14.5207 15.7233C15.729 15.7233 16.7104 14.7933 16.7104 13.651ZM18.6449 13.651C18.6449 15.8026 16.7956 17.554 14.5207 17.554C12.2471 17.554 10.3965 15.8026 10.3965 13.651C10.3965 11.4994 12.2471 9.74805 14.5207 9.74805C16.7956 9.74805 18.6449 11.4994 18.6449 13.651ZM32.3204 13.6512C32.3204 13.146 31.8871 12.7359 31.3532 12.7359H23.422C22.8881 12.7359 22.4548 13.146 22.4548 13.6512C22.4548 14.1565 22.8881 14.5666 23.422 14.5666H31.3532C31.8871 14.5666 32.3204 14.1565 32.3204 13.6512ZM26.006 25.813C26.006 26.9553 26.9874 27.8853 28.1958 27.8853C29.4042 27.8853 30.3856 26.9553 30.3856 25.813C30.3856 24.6695 29.4042 23.7407 28.1958 23.7407C26.9874 23.7407 26.006 24.6695 26.006 25.813ZM24.0716 25.813C24.0716 23.6602 25.9209 21.9101 28.1958 21.9101C30.4707 21.9101 32.32 23.6602 32.32 25.813C32.32 27.9646 30.4707 29.716 28.1958 29.716C25.9209 29.716 24.0716 27.9646 24.0716 25.813ZM11.3646 24.8973H19.2945C19.8284 24.8973 20.2617 25.3074 20.2617 25.8127C20.2617 26.3179 19.8284 26.728 19.2945 26.728H11.3646C10.8307 26.728 10.3974 26.3179 10.3974 25.8127C10.3974 25.3074 10.8307 24.8973 11.3646 24.8973Z"
        fill="#0065FC"
      />
      <rect
        opacity="1"
        x="0.704102"
        y="0.621094"
        width="40"
        height="40"
        rx="4.5"
        stroke="#F0F0F0"
      />
    </svg>
  );
};
const Usericon = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M29.8625 0.959961C30.1881 0.959961 30.5003 1.09222 30.7305 1.32764C30.9607 1.56307 31.09 1.88237 31.09 2.2153V5.98134H34.7725C35.0981 5.98134 35.4103 6.11359 35.6405 6.34902C35.8707 6.58444 36 6.90374 36 7.23668C36 7.56962 35.8707 7.88892 35.6405 8.12434C35.4103 8.35976 35.0981 8.49202 34.7725 8.49202H31.09V12.2581C31.09 12.591 30.9607 12.9103 30.7305 13.1457C30.5003 13.3811 30.1881 13.5134 29.8625 13.5134C29.537 13.5134 29.2248 13.3811 28.9946 13.1457C28.7644 12.9103 28.635 12.591 28.635 12.2581V8.49202H24.9525C24.627 8.49202 24.3148 8.35976 24.0846 8.12434C23.8544 7.88892 23.7251 7.56962 23.7251 7.23668C23.7251 6.90374 23.8544 6.58444 24.0846 6.34902C24.3148 6.11359 24.627 5.98134 24.9525 5.98134H28.635V2.2153C28.635 1.88237 28.7644 1.56307 28.9946 1.32764C29.2248 1.09222 29.537 0.959961 29.8625 0.959961ZM13.0868 9.32892C12.3345 9.32892 11.5896 9.48045 10.8946 9.77485C10.1996 10.0693 9.56816 10.5008 9.03624 11.0448C8.50432 11.5888 8.08237 12.2346 7.7945 12.9453C7.50662 13.6561 7.35846 14.4179 7.35846 15.1872C7.35846 15.9565 7.50662 16.7183 7.7945 17.4291C8.08237 18.1398 8.50432 18.7856 9.03624 19.3296C9.56816 19.8736 10.1996 20.3051 10.8946 20.5995C11.5896 20.8939 12.3345 21.0455 13.0868 21.0455C14.606 21.0455 16.063 20.4282 17.1373 19.3296C18.2116 18.231 18.8151 16.7409 18.8151 15.1872C18.8151 13.6335 18.2116 12.1434 17.1373 11.0448C16.063 9.94613 14.606 9.32892 13.0868 9.32892ZM4.90347 15.1872C4.90357 13.7533 5.26392 12.3435 5.94995 11.0929C6.63598 9.84238 7.62469 8.79309 8.82125 8.04567C10.0178 7.29825 11.3821 6.87778 12.7832 6.82459C14.1843 6.7714 15.5753 7.08727 16.8228 7.7419C18.0702 8.39654 19.1323 9.36798 19.9071 10.5631C20.6819 11.7581 21.1434 13.1368 21.2475 14.5667C21.3516 15.9967 21.0946 17.43 20.5013 18.7292C19.908 20.0284 18.9982 21.1499 17.8593 21.9861C20.2224 22.9491 22.2587 24.5975 23.7178 26.7285C25.177 28.8595 25.9953 31.3802 26.072 33.9805C26.0804 34.1475 26.056 34.3144 26.0004 34.4716C25.9448 34.6288 25.8591 34.773 25.7483 34.8959C25.6375 35.0187 25.5038 35.1177 25.355 35.187C25.2063 35.2563 25.0455 35.2945 24.8821 35.2994C24.7188 35.3043 24.5561 35.2758 24.4036 35.2156C24.2512 35.1553 24.112 35.0645 23.9943 34.9485C23.8767 34.8325 23.7828 34.6937 23.7183 34.5401C23.6538 34.3865 23.6199 34.2213 23.6187 34.0542C23.5349 31.2409 22.3832 28.5715 20.4077 26.6118C18.4322 24.6521 15.7882 23.5561 13.036 23.5561C10.2839 23.5561 7.63985 24.6521 5.66437 26.6118C3.68889 28.5715 2.5372 31.2409 2.45339 34.0542C2.437 34.382 2.29574 34.6901 2.05987 34.9127C1.824 35.1353 1.51227 35.2545 1.19148 35.2449C0.870687 35.2352 0.566339 35.0975 0.343638 34.8612C0.120936 34.6249 -0.00240573 34.3087 3.5561e-05 33.9805C0.0775611 31.368 0.903547 28.8362 2.37548 26.6995C3.84741 24.5628 5.90049 22.9151 8.2799 21.961C7.23344 21.1854 6.38178 20.1671 5.79483 18.9895C5.20789 17.812 4.90241 16.5089 4.90347 15.1872Z"
        fill="black"
      />
    </svg>
  );
};
export const BuyerFound = () => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.4427 0C12.5784 0 12.7085 0.0577719 12.8044 0.160606C12.9003 0.263441 12.9542 0.402915 12.9542 0.548345V2.19338H14.4885C14.6242 2.19338 14.7543 2.25115 14.8502 2.35398C14.9461 2.45682 15 2.59629 15 2.74172C15 2.88715 14.9461 3.02663 14.8502 3.12946C14.7543 3.2323 14.6242 3.29007 14.4885 3.29007H12.9542V4.9351C12.9542 5.08053 12.9003 5.22 12.8044 5.32284C12.7085 5.42567 12.5784 5.48345 12.4427 5.48345C12.3071 5.48345 12.177 5.42567 12.0811 5.32284C11.9851 5.22 11.9313 5.08053 11.9313 4.9351V3.29007H10.3969C10.2612 3.29007 10.1312 3.2323 10.0352 3.12946C9.93932 3.02663 9.88544 2.88715 9.88544 2.74172C9.88544 2.59629 9.93932 2.45682 10.0352 2.35398C10.1312 2.25115 10.2612 2.19338 10.3969 2.19338H11.9313V0.548345C11.9313 0.402915 11.9851 0.263441 12.0811 0.160606C12.177 0.0577719 12.3071 0 12.4427 0ZM5.45282 3.65563C5.13938 3.65563 4.82901 3.72182 4.53943 3.85042C4.24985 3.97902 3.98673 4.16751 3.7651 4.40513C3.54347 4.64275 3.36766 4.92484 3.24771 5.23531C3.12776 5.54577 3.06602 5.87853 3.06602 6.21457C3.06602 6.55062 3.12776 6.88337 3.24771 7.19384C3.36766 7.5043 3.54347 7.7864 3.7651 8.02402C3.98673 8.26164 4.24985 8.45013 4.53943 8.57872C4.82901 8.70732 5.13938 8.77351 5.45282 8.77351C6.08584 8.77351 6.69293 8.50391 7.14054 8.02402C7.58815 7.54412 7.83961 6.89325 7.83961 6.21457C7.83961 5.5359 7.58815 4.88502 7.14054 4.40513C6.69293 3.92523 6.08584 3.65563 5.45282 3.65563ZM2.04311 6.21457C2.04315 5.58823 2.1933 4.97241 2.47915 4.42616C2.76499 3.87992 3.17696 3.42157 3.67552 3.0951C4.17409 2.76862 4.74253 2.58495 5.32633 2.56172C5.91014 2.53848 6.48972 2.67646 7.00949 2.96241C7.52926 3.24836 7.97178 3.67269 8.29462 4.19471C8.61745 4.71673 8.80977 5.31893 8.85312 5.94354C8.89648 6.56816 8.78942 7.19424 8.54221 7.76174C8.29499 8.32924 7.91593 8.81912 7.44136 9.18441C8.42599 9.60506 9.27447 10.3251 9.88244 11.2559C10.4904 12.1868 10.8314 13.2878 10.8633 14.4237C10.8668 14.4966 10.8567 14.5695 10.8335 14.6382C10.8104 14.7068 10.7746 14.7698 10.7285 14.8235C10.6823 14.8772 10.6266 14.9204 10.5646 14.9507C10.5026 14.9809 10.4356 14.9976 10.3676 14.9998C10.2995 15.0019 10.2317 14.9895 10.1682 14.9631C10.1047 14.9368 10.0467 14.8972 9.99764 14.8465C9.94861 14.7958 9.9095 14.7352 9.88262 14.6681C9.85574 14.601 9.84163 14.5288 9.84111 14.4558C9.80619 13.227 9.32632 12.061 8.5032 11.2049C7.68009 10.3489 6.57841 9.87019 5.43168 9.87019C4.28494 9.87019 3.18327 10.3489 2.36015 11.2049C1.53704 12.061 1.05716 13.227 1.02225 14.4558C1.01542 14.599 0.956559 14.7336 0.858279 14.8308C0.759998 14.9281 0.630114 14.9801 0.49645 14.9759C0.362786 14.9717 0.235975 14.9116 0.143182 14.8083C0.0503901 14.7051 -0.00100239 14.567 1.48171e-05 14.4237C0.0323171 13.2825 0.376478 12.1766 0.989783 11.2432C1.60309 10.3099 2.45854 9.59019 3.44996 9.17344C3.01393 8.83465 2.65907 8.38982 2.41451 7.87546C2.16996 7.36111 2.04267 6.7919 2.04311 6.21457Z"
        fill="#666666"
      />
    </svg>
  );
};
const BuyerCallIcon = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        opacity="0.1"
        x="0.5"
        y="0.5"
        width="29"
        height="29"
        rx="4.5"
        stroke="#112347"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.6164 11.6322C10.7873 11.3492 11.7287 10.3202 12.4005 10.3513C12.6014 10.3679 12.7789 10.4894 12.9231 10.6303C13.2543 10.9537 14.2024 12.1769 14.2562 12.4343C14.3871 13.0656 13.6349 13.4295 13.8651 14.0658C14.452 15.502 15.4634 16.5132 16.9002 17.0996C17.5359 17.3298 17.8999 16.5776 18.5312 16.7091C18.788 16.7629 20.0118 17.7109 20.3353 18.0421C20.4756 18.1858 20.5977 18.3638 20.6143 18.5646C20.6393 19.2719 19.5464 20.2266 19.3334 20.3487C18.8308 20.7081 18.175 20.702 17.3756 20.3303C15.1449 19.4023 11.58 15.9047 10.6347 13.5898C10.273 12.7949 10.2481 12.1347 10.6164 11.6322Z"
        stroke="#6C2AD2"
        stroke-width="0.81025"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
const BuyerMsgIcon = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        opacity="0.1"
        x="0.5"
        y="0.5"
        width="29"
        height="29"
        rx="4.5"
        stroke="#112347"
      />
      <path
        d="M8 11.5C8 10.3954 8.89543 9.5 10 9.5H21C22.1046 9.5 23 10.3954 23 11.5V18.125C23 19.2296 22.1046 20.125 21 20.125H10C8.89543 20.125 8 19.2296 8 18.125V11.5Z"
        stroke="#6C2AD2"
        stroke-linejoin="round"
      />
      <path
        d="M9.42131 10.8029C8.91709 10.3407 9.24409 9.5 9.9281 9.5H21.0719C21.7559 9.5 22.0829 10.3407 21.5787 10.8029L17.5272 14.5168C16.3802 15.5681 14.6198 15.5681 13.4728 14.5168L9.42131 10.8029Z"
        stroke="#6C2AD2"
        stroke-linejoin="round"
      />
    </svg>
  );
};

const ToggeleIconViewType = () => {
  return (
    <svg
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_33347_144768)">
        <path
          d="M18.3425 5.75H16.1L19.78 9.6485L22.793 5.75H20.746C20.746 2.4265 18.5725 0 14.95 0V2.415C17.365 2.415 18.3425 3.749 18.3425 5.75ZM1.15002 1.15H12.65V11.5H23V23H6.90002V17.25H1.15002V1.15ZM2.02947 2.02941V16.2353H6.90002V11.5H11.8383V2.02941H2.02947ZM7.77947 12.5147V21.9853H21.9854V12.5147H7.77947Z"
          fill="#007AFF"
        />
      </g>
      <defs>
        <clipPath id="clip0_33347_144768">
          <rect width="23" height="23" fill="red" />
        </clipPath>
      </defs>
    </svg>
  );
};
const Invertedmenu = () => {
  return (
    <svg
      width="21"
      height="5"
      viewBox="0 0 21 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.1816 2.49996C12.1816 3.4303 11.4274 4.18449 10.497 4.18449C9.56669 4.18449 8.8125 3.4303 8.8125 2.49996C8.8125 1.56962 9.56669 0.81543 10.497 0.81543C11.4274 0.81543 12.1816 1.56962 12.1816 2.49996Z"
        fill="#666666"
      />
      <path
        d="M3.75968 2.49996C3.75968 3.4303 3.00549 4.18449 2.07515 4.18449C1.14481 4.18449 0.390625 3.4303 0.390625 2.49996C0.390625 1.56962 1.14481 0.81543 2.07515 0.81543C3.00549 0.81543 3.75968 1.56962 3.75968 2.49996Z"
        fill="#666666"
      />
      <path
        d="M20.6034 2.49996C20.6034 3.4303 19.8492 4.18449 18.9189 4.18449C17.9886 4.18449 17.2344 3.4303 17.2344 2.49996C17.2344 1.56962 17.9886 0.81543 18.9189 0.81543C19.8492 0.81543 20.6034 1.56962 20.6034 2.49996Z"
        fill="#666666"
      />
    </svg>
  );
};

function BuyerRegistration(props) {
  const history = useHistory();
  const [selbuyerId, setSelbuyerId] = useState(0);
  const [buyerpropertylist, setBuyerpropertylist] = useState({});
  const [portraitMode, setPortraitMode] = useState(true);
  const data = props?.profileDetails?.BuyerRegisterDetails;
  const connectedData = props?.profileDetails?.buyerRegisterDetailsConnected;
  const pendingData = props?.profileDetails?.buyerRegisterDetailsPending;
  const datalength = props?.profileDetails?.BuyerRegisterDetails?.length;
  const address =
    props?.profileDetails?.PropertyDetails?.propertyAddress?.streetName;
  const propertyUniqueId =
    props?.profileDetails?.PropertyDetails?.property?.propertyUniqueId;

  const [isSortClicked, setIsSortClicked] = useState(false);
  const stage = props?.profileDetails?.PropertyDetails?.stage;
  const [searchValue, setSearchValue] = useState('');
  const theme = useTheme();
  const {
    getListInfo,
    onShowChat,
    vendorside,
    propertyId,
    activityfun,
    publishwinner,
    getdata,
    userTypeValue,
    realTimeLog,
    onFilterUpdate,
    vendorDatas,
    setEsignOpen,
    setIsSwalOpen,
    setVendorGeneratePdf,
  } = props;

  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matcheslg = useMediaQuery(theme.breakpoints.down('lg'));
  const matchesmd = useMediaQuery(theme.breakpoints.down('md'));
  const matches700 = useMediaQuery(theme.breakpoints.down(700));
  const propertyid =
    props?.profileDetails?.PropertyDetails?.property?.propertyId;
  const agencyId = JSON.parse(localStorage.getItem('userDetail')).userId;
  const Activityid = JSON.parse(localStorage.getItem('userDetail')).userId;
  const [register, setRegister] = useState(false);
  const [checkin, setCheckin] = useState(false);
  const [quickswitch, setQuickswitch] = useState(false);
  const [filter, setFilter] = useState(false);
  const [mainFilter, setMainFilter] = useState(data);
  const [subFilter, setSubFilter] = useState(data);
  const [activity, setActivity] = useState('Activity');
  const [slidervalue, setSlidervalue] = React.useState([0, 30000000]);
  const params = useParams();
  const [properties, setProperties] = useState([]);
  const debounceTimeout = useRef(null);
  const [showEngagedTable, setShowEngagedTable] = useState(true);
  const [showConnectedTable, setShowConnectedTable] = useState(true);
  const [showPendingTable, setShowPendingTable] = useState(true);
  const [isPipelineCat, setIsPipelineCat] = useState(null);
  const [pipelineCat, setPipelineCat] = useState(null);
  const [pipelineId, setPipelineId] = useState(null);
  const [isAppraisal, setIsAppraisal] = useState(null);

  useEffect(() => {
    if (onFilterUpdate) {
      onFilterUpdate(mainFilter);
    }
  }, [mainFilter, onFilterUpdate]);

  const handleChangeforslider = (event, newValue) => {
    setSlidervalue(newValue);
  };
  // function valueLabelFormat(slidervalue) {
  //   const units = '$';
  //   return `${units}${slidervalue}`;
  // }
  function valueLabelFormat(slidervalue) {
    return `$${Number(slidervalue).toLocaleString('en-US')}`;
  }
  useEffect(() => {
    setMainFilter(data);
    setSubFilter(data);
  }, [data]);
  useEffect(() => {
    activityFilter(activity);
  }, [isSortClicked]);
  useEffect(() => {
    Propertylist();
  }, [selbuyerId]);

  const Propertylist = () => {
    if (selbuyerId !== 0) {
      let url = PROPERTYLIST_COMMON + '/Buyer/' + selbuyerId;
      getApiCall(url).then((res) => {
        setBuyerpropertylist(res?.data?.data);
        setPipelineId(res?.data?.data?.[0]?.pd_pipelineId);
        setPipelineCat(res?.data?.data?.[0]?.pd_categoryId);
        setIsPipelineCat(res?.data?.data?.[0]?.isPipelineProperty);
        setIsAppraisal(res?.data?.data?.[0]?.pd_isAppraisal);
      });
    }
  };
  const searchFilter = (val) => {
    let value = String(val).toLowerCase();
    if (value == '') {
      setMainFilter(subFilter);
      return;
    } else {
      let filteredResult = subFilter?.filter((item) => {
        return (
          String(
            item?.buyerDetails?.user?.userName +
              ' ' +
              item?.buyerDetails?.user?.userSurName || ''
          )
            ?.toLowerCase()
            ?.includes(value) ||
          String(
            item?.buyerDetails?.user?.userName +
              ' ' +
              item?.buyerDetails?.user?.userSurName || ''
          )?.includes(value) ||
          String(item?.buyerOfferPrice || '')
            ?.toLowerCase()
            ?.includes(value) ||
          String(item?.buyerDetails?.noOfOffers || '')
            ?.toLowerCase()
            ?.includes(value) ||
          String(item?.buyerDetails?.rating || '')
            ?.toLowerCase()
            ?.includes(value) ||
          String(item?.buyerDetails?.exp || '')
            ?.toLowerCase()
            ?.includes(value) ||
          String(item?.buyerDetails?.profile || '')
            ?.toLowerCase()
            ?.includes(value) ||
          String(item?.buyerDetails?.profile || '')?.includes(value) ||
          String(item?.buyerDetails?.rediness || '')
            ?.toLowerCase()
            ?.match(value) ||
          String(item?.buyerOfferDetails?.offerStatus || '')
            ?.toLowerCase()
            ?.match(value) ||
          String(item?.buyerOfferDetails?.offerStatus || '')?.match(value) ||
          String(item?.buyerOfferDetails?.offerStatusVendor || '')
            ?.toLowerCase()
            ?.match(value) ||
          String(item?.buyerOfferDetails?.offerStatusVendor || '')?.match(value)
        );
      });
      setMainFilter(filteredResult);
    }
  };
  const compareByIntAsc = (a, b) => {
    return (
      (Number(a?.buyerDetails?.interestedAvg) || 0) -
      (Number(b?.buyerDetails?.interestedAvg) || 0)
    );
  };
  const compareByIntDsc = (a, b) => {
    return (
      (Number(b?.buyerDetails?.rating) || 0) -
      (Number(a?.buyerDetails?.rating) || 0)
    );
  };
  const compareByRedAsc = (a, b) => {
    return (
      (parseFloat(a?.buyerDetails?.rediness) || 0) -
      (parseFloat(b?.buyerDetails?.rediness) || 0)
    );
  };
  const compareByRedDsc = (a, b) => {
    return (
      (parseFloat(b?.buyerDetails?.rediness) || 0) -
      (parseFloat(a?.buyerDetails?.rediness) || 0)
    );
  };
  const compareByNameAsc = (a, b) => {
    return a.buyerDetails?.user?.userName?.localeCompare(
      b?.buyerDetails?.user?.userName,
      undefined,
      { numeric: true, sensitivity: 'base' }
    );
  };
  const compareByNameDsc = (a, b) => {
    return b.buyerDetails?.user?.userName?.localeCompare(
      a?.buyerDetails?.user?.userName,
      undefined,
      { numeric: true, sensitivity: 'base' }
    );
  };
  const compareBy66wAsc = (a, b) => {
    return a.buyerDetails?.is66Signed?.localeCompare(
      b?.buyerDetails?.is66Signed,
      undefined,
      { numeric: true, sensitivity: 'base' }
    );
  };
  const compareBy66wDsc = (a, b) => {
    return b.buyerDetails?.is66Signed?.localeCompare(
      a?.buyerDetails?.is66Signed,
      undefined,
      { numeric: true, sensitivity: 'base' }
    );
  };

  const compareByNoOfOffersAsc = (a, b) => {
    return (
      (a.buyerDetails?.noOfOffers || 0) - (b.buyerDetails?.noOfOffers || 0)
    );
  };

  const compareByNoOfOffersDsc = (a, b) => {
    return (
      (b.buyerDetails?.noOfOffers || 0) - (a.buyerDetails?.noOfOffers || 0)
    );
  };

  const compareByOfferPriceAsc = (a, b) => {
    return a.buyerOfferPrice
      .toString()
      ?.localeCompare((b?.buyerOfferPrice).toString());
  };
  const compareByOfferPriceDsc = (a, b) => {
    return b.buyerOfferPrice
      .toString()
      ?.localeCompare((a?.buyerOfferPrice).toString());
  };
  const compareByOffDateDsc = (a, b) => {
    const dateA =
      a?.buyerOfferDetails && a?.buyerOfferDetails?.createdAt
        ? new Date(a.buyerOfferDetails.createdAt)
        : null;

    const dateB =
      b?.buyerOfferDetails && b?.buyerOfferDetails?.createdAt
        ? new Date(b.buyerOfferDetails.createdAt)
        : null;

    if (dateA && dateB) {
      return dateB - dateA;
    } else if (dateA) {
      return -1;
    } else if (dateB) {
      return 1;
    } else {
      return 0;
    }
  };
  const compareByOffDateAsc = (a, b) => {
    const dateA =
      a?.buyerOfferDetails && a?.buyerOfferDetails?.createdAt
        ? new Date(a.buyerOfferDetails.createdAt)
        : null;

    const dateB =
      b?.buyerOfferDetails && b?.buyerOfferDetails?.createdAt
        ? new Date(b.buyerOfferDetails.createdAt)
        : null;

    if (dateA && dateB) {
      return dateA - dateB;
    } else if (dateA) {
      return -1;
    } else if (dateB) {
      return 1;
    } else {
      return 0;
    }
  };
  const compareByExpAsc = (a, b) => {
    return (a.buyerDetails?.exp)
      .toString()
      ?.localeCompare((b?.buyerDetails?.exp).toString());
  };
  const compareByExpDsc = (a, b) => {
    return (b.buyerDetails?.exp)
      .toString()
      ?.localeCompare((a?.buyerDetails?.exp).toString());
  };

  const compareByRatingAsc = (a, b) => {
    return (
      Number(a.buyerDetails?.rating || 0) - Number(b.buyerDetails?.rating || 0)
    );
  };

  const compareByRatingDsc = (a, b) => {
    return (
      Number(b.buyerDetails?.rating || 0) - Number(a.buyerDetails?.rating || 0)
    );
  };

  const activityFilter = (value) => {
    try {
      if (value === 'Activity' && isSortClicked) {
        setMainFilter((array) => [...subFilter.reverse()]);
      } else {
        if (value === 'Interest') {
          if (isSortClicked) {
            setMainFilter([...mainFilter.sort(compareByIntDsc)]);
          } else {
            setMainFilter([...mainFilter.sort(compareByIntAsc)]);
          }
        } else if (value === 'Readiness') {
          if (isSortClicked) {
            setMainFilter([...mainFilter.sort(compareByRedDsc)]);
          } else {
            setMainFilter([...mainFilter.sort(compareByRedAsc)]);
          }
        } else if (value === '66W') {
          if (isSortClicked) {
            setMainFilter([
              ...mainFilter.sort((a, b) => {
                const valA = a?.buyerDetails?.is66Signed ?? 0;
                const valB = b?.buyerDetails?.is66Signed ?? 0;
                return valB - valA; // descending
              }),
            ]);
          } else {
            setMainFilter([
              ...mainFilter.sort((a, b) => {
                const valA = a?.buyerDetails?.is66Signed ?? 0;
                const valB = b?.buyerDetails?.is66Signed ?? 0;
                return valA - valB; // ascending
              }),
            ]);
          }
        } else if (value === 'Offer') {
          if (isSortClicked) {
            setMainFilter([...mainFilter.sort(compareByOfferPriceDsc)]);
          } else {
            setMainFilter([...mainFilter.sort(compareByOfferPriceAsc)]);
          }
        } else if (value === 'Numberofoffers') {
          if (isSortClicked) {
            setMainFilter([...mainFilter.sort(compareByNoOfOffersDsc)]);
          } else {
            setMainFilter([...mainFilter.sort(compareByNoOfOffersAsc)]);
          }
        } else if (value === 'Buyerrating') {
          if (isSortClicked) {
            setMainFilter([...mainFilter.sort(compareByRatingDsc)]);
          } else {
            setMainFilter([...mainFilter.sort(compareByRatingAsc)]);
          }
        } else if (value === 'Buyerexperience') {
          if (isSortClicked) {
            setMainFilter([...mainFilter.sort(compareByExpDsc)]);
          } else {
            setMainFilter([...mainFilter.sort(compareByExpAsc)]);
          }
        } else if (value === 'Name') {
          if (isSortClicked) {
            setMainFilter([...mainFilter.sort(compareByNameDsc)]);
          } else {
            setMainFilter([...mainFilter.sort(compareByNameAsc)]);
          }
        } else if (value === 'Offer date') {
          if (isSortClicked) {
            setMainFilter([...mainFilter.sort(compareByOffDateDsc)]);
          } else {
            setMainFilter([...mainFilter.sort(compareByOffDateAsc)]);
          }
        }
      }
    } catch (error) {
      console.log(error, 'errorrrr');
    }
  };
  const [formValues, setFormValues] = useState({
    name: {
      value: '',
      error: false,
      errorMessage: 'Please enter the firstname',
    },
    surname: {
      value: '',
      error: false,
      errorMessage: 'Please enter the surname',
    },
    userEmail: {
      value: '',
      error: false,
      errorMessage: 'Please enter the email address',
    },
    userPhoneNo: {
      value: '',
      error: false,
      errorMessage: 'Please enter the phone number',
    },
  });
  const [formValuesempty, setFormValuesempty] = useState({
    name: {
      value: '',
      error: false,
      errorMessage: 'Please enter the firstname',
    },
    surname: {
      value: '',
      error: false,
      errorMessage: 'Please enter the surname',
    },
    userEmail: {
      value: '',
      error: false,
      errorMessage: 'Please enter the correct email address',
    },
    userPhoneNo: {
      value: '',
      error: false,
      errorMessage: 'Please enter the phone number',
    },
  });
  const [inputsetone, setInputsetone] = useState(false);
  const [inputsettwo, setInputsettwo] = useState(false);

  // prefill in form for unavailable buyer details
  const prefillFromSearch = (keyword) => {
    if (!keyword) return;

    const value = keyword.trim();

    setFormValues((prev) => {
      const updated = { ...prev };

      // reset all values first
      updated.name.value = '';
      updated.surname.value = '';
      updated.userEmail.value = '';
      updated.userPhoneNo.value = '';
      if (value.includes('@')) {
        updated.userEmail.value = value.toLowerCase();
      }
      // only numbers → phone
      else if (/^[\d\s]+$/.test(value)) {
        updated.userPhoneNo.value = value;
      }
      // combination of letters and numbers → email
      else if (/[a-zA-Z]/.test(value) && /\d/.test(value)) {
        updated.userEmail.value = value.toLowerCase();
      }
      // only letters → name
      else if (/^[a-zA-Z]+$/.test(value)) {
        updated.name.value = value;
      }

      return updated;
    });
  };

  const handleChange = (e) => {
    setCheckInSuggestion('');
    BuyerPrefill(e.target.value);

    const { name, value } = e.target;

    setNameAnchorEl(null);
    setSurnameAnchorEl(null);
    setEmailAnchorEl(null);
    setMobileAnchorEl(null);

    if (value.length > 0) {
      if (name == 'name') {
        setNameAnchorEl(e.target);
      } else if (name == 'surname') {
        setSurnameAnchorEl(e.target);
      } else if (name == 'userEmail') {
        setEmailAnchorEl(e.target);
      } else if (name == 'userPhoneNo') {
        setMobileAnchorEl(e.target);
      }
    }

    if (name === 'userPhoneNo') {
      const inputElement = e.target;
      const rawValue = value;
      const prevValue = inputElement?.value || '';
      const cursorPosition = inputElement?.selectionStart || 0;

      const isBackspace = prevValue.length > rawValue.length;
      const numericValue = rawValue.replace(/\D/g, '');
      let formattedValue = numericValue
        .replace(/^(\d{0,4})(\d{0,3})(\d{0,3})$/, '$1 $2 $3')
        .trim();

      let error = false;
      let errorMessage = '';

      // Only show format error during typing if field has value
      if (numericValue.length > 0) {
        const numericOnly = formattedValue.replace(/\s/g, '');
        if (!/^04\d{2}\d{3}\d{3}$/.test(numericOnly)) {
          error = true;
          errorMessage = 'Mobile number format should be: 04XX XXX XXX';
        }
      }
      // Don't set empty field error during typing - only on submit

      setFormValues((prevState) => ({
        ...prevState,
        userPhoneNo: {
          ...prevState.userPhoneNo,
          value: formattedValue,
          error: error,
          errorMessage: errorMessage,
        },
      }));

      requestAnimationFrame(() => {
        if (!inputElement) return;
        const digitsBeforeCursor = rawValue
          .slice(0, cursorPosition)
          .replace(/\D/g, '').length;
        let actualCursor = 0;
        let digitCount = 0;
        while (
          digitCount < digitsBeforeCursor &&
          actualCursor < formattedValue.length
        ) {
          if (/\d/.test(formattedValue[actualCursor])) digitCount++;
          actualCursor++;
        }
        inputElement.setSelectionRange(actualCursor, actualCursor);
      });
    } else {
      const updatedValue = name === 'userEmail' ? value.toLowerCase() : value;

      let error = false;
      if (name === 'userEmail') {
        error = updatedValue && validateEmail(updatedValue);
      }
      setFormValues((prevState) => ({
        ...prevState,
        [name]: {
          ...prevState[name],
          value: updatedValue,
          error: error,
        },
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let triggerSubmit = true;
    const formFields = Object.keys(formValues);
    let newFormValues = { ...formValues };

    for (let index = 0; index < formFields.length; index++) {
      const currentField = formFields[index];
      const currentValue = formValues[currentField].value;

      if (currentField === 'userPhoneNo') {
        const numericValue = currentValue.replace(/\D/g, '');
        if (numericValue.length === 0) {
          triggerSubmit = false;
          newFormValues = {
            ...newFormValues,
            [currentField]: {
              ...newFormValues[currentField],
              value: currentValue,
              error: true,
              errorMessage: 'Please enter the phone number',
            },
          };
        } else if (!/^04\d{2}\d{3}\d{3}$/.test(numericValue)) {
          triggerSubmit = false;
          newFormValues = {
            ...newFormValues,
            [currentField]: {
              ...newFormValues[currentField],
              value: currentValue,
              error: true,
              errorMessage: 'Mobile number format should be: 04XX XXX XXX',
            },
          };
        }
      } else if (currentValue === '') {
        triggerSubmit = false;
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            value: currentValue,
            error: true,
          },
        };
      }
    }

    setFormValues(newFormValues);
    if (triggerSubmit) {
      signUpHandler(newFormValues);
    }
  };
  const [loading, setLoading] = useState(false);
  const handlefirstset = () => {
    if (!validateEmail(formValues.userEmail.value)) {
      if (
        formValues.name.value &&
        formValues.surname.value &&
        formValues.userEmail.value &&
        !formValues.name.error &&
        !formValues.surname.error &&
        !formValues.userEmail.error
      ) {
        setInputsetone(false);
        setInputsettwo(true);
      } else {
        if (!formValues.name.value) {
          setFormValues((prevState) => ({
            ...prevState,
            name: {
              value: '',
              error: true,
              errorMessage: 'Please enter the name',
            },
          }));
        }
        if (!formValues.surname.value) {
          setFormValues((prevState) => ({
            ...prevState,
            surname: {
              value: '',
              error: true,
              errorMessage: 'Please enter surname',
            },
          }));
        }
        if (!formValues.userEmail.value) {
          setFormValues((prevState) => ({
            ...prevState,
            userEmail: {
              value: '',
              error: true,
              errorMessage: 'Please enter the correct email address',
            },
          }));
        }
      }
    } else {
      setFormValues((prevState) => ({
        ...prevState,
        userEmail: {
          value: formValues.userEmail.value,
          error: true,
          errorMessage: 'Please enter the correct email address',
        },
      }));
    }
  };

  const [foundData, setFoundData] = useState(false);
  const [buyerFounding, setBuyerFounding] = React.useState('');
  const [showScannerloader, setShowScannerloader] = useState(false);

  function CircularProgressWithProfile(props) {
    return (
      <Box sx={{ position: 'relative', display: 'inline-flex' }}>
        <CircularProgress
          variant="determinate"
          value={100}
          sx={{ color: '#C4C4C461' }}
          thickness={5}
          size={43}
        />
        <CircularProgress
          variant="determinate"
          value={props.value}
          sx={{ color: '#10D35E', position: 'absolute' }}
          thickness={5}
          size={43}
        />
        <Box
          sx={{
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            position: 'absolute',
          }}
        >
          <Typography
            variant="caption"
            component="div"
            sx={{ color: '#000000', ...poppins500, fontSize: '14px' }}
          >
            <Avatar
              alt="Remy"
              src={props.profileImage}
              style={{
                width: '36px',
                height: '36px',
              }}
            />
          </Typography>
        </Box>
      </Box>
    );
  }

  const [buyerClicked, setBuyerClicked] = useState(false);

  const clickNewBuyer = () => {
    setBuyerClicked(true);
  };

  const clickNewUser = () => {
    setBuyerClicked(true);
    prefillFromSearch(anchorEl);
  };

  const DisableClickNewBuyer = () => {
    return setBuyerClicked(false);
  };

  const [anchorEl, setAnchorEl] = useState('');
  const [checkInData, setCheckInData] = useState();
  const [searchCheckInUser, setSearchCheckInUser] = useState();
  const [checkInIndex, setCheckInIndex] = useState();
  const [checkInErrorData, setCheckInErrorData] = useState();

  const [nameAnchorEl, setNameAnchorEl] = useState(null);
  const [surnameAnchorEl, setSurnameAnchorEl] = useState(null);
  const [emailAnchorEl, setEmailAnchorEl] = useState(null);
  const [mobileAnchorEl, setMobileAnchorEl] = useState(null);
  const [activeIndex, setActiveIndex] = React.useState(0);

  const calcMarginTop = (idx = 0) => {
    const datesLen =
      checkInData?.userData?.[idx]?.userInspectedDates?.length ?? 0;
    return datesLen > 0 && !checkInErrorData ? 410 + (datesLen - 1) * 24 : 270;
  };
  const [tooManyResults, setTooManyResults] = useState(false);

  const [buyerSearchLoader, setBuyerSearchLoader] = useState(false);

  const buyerCheckin = async (data, { force = false } = {}) => {
    setBuyerSearchLoader(true);
    // normalize input (guard)
    if (!data || data.length === 0) {
      // If input cleared, reset blocker and state so next typing will trigger API again
      setTooManyResults(false);
      setCheckInData(null);
      setCheckInErrorData('');
      setFoundData(false);
      return;
    }

    // If blocked due to too many results and caller hasn't forced the search,
    // don't call the API until user types >= 3 chars.
    if (tooManyResults && data.length < 3 && !force) {
      setCheckInData(null);
      setCheckInErrorData(
        'Type atleast three charcters to get filtered results'
      );
      setFoundData(false);
      return;
    }

    // Build request payload
    const inputData = {
      contactValue: data,
      propertyId: propertyid,
    };

    setFoundData(true);
    setCheckInErrorData(''); // clear any existing error message while loading

    try {
      const res = await postApiCall(BUYER_CHECK_IN, inputData);

      if (res?.data?.status == 1) {
        const resultCount = res?.data?.userData?.length ?? 0;

        // If this was the initial 1-char call and there are >= 5 results,
        // set the blocker and DO NOT display results.
        if (data.length === 1 && resultCount >= 5) {
          setTooManyResults(true);
          setCheckInData(null); // don't show results
          setCheckInErrorData(''); // clear any previous error
          setFoundData(false);
          return;
        }

        // Otherwise show results and clear any previous blocker
        setTooManyResults(false);
        setCheckInData(res?.data);
        setCheckInErrorData('');
      } else {
        setCheckInErrorData(res?.data);
      }

      setFoundData(false);
    } catch (error) {
      setFoundData(false);
      setCheckInData(null);
      setCheckInErrorData('An error occurred. Please try again.');
    } finally {
      setBuyerSearchLoader(false);
    }
  };

  // Input change handler with correct empty-check and debounce reset
  const handleInputChangeBuyercheckin = (e) => {
    // don't trim numeric spaces for formatting step; trim mainly for empty-check
    let raw = e.target.value ?? '';
    const trimmed = raw.trim();

    // If user cleared input completely -> reset everything and clear debounce
    if (trimmed.length === 0) {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
      setTooManyResults(false);
      setCheckInData(null);
      setCheckInErrorData('');
      setFoundData(false);
      setAnchorEl(''); // clear input state shown in UI
      return;
    }

    // Determine if the input is numeric (phone) - allow spaces while typing
    const isNumeric = /^\d+$/.test(raw.replace(/\s+/g, ''));

    if (isNumeric) {
      // keep only digits, limit to 10 and format into groups
      const cleanedDigits = raw.replace(/\D/g, '').slice(0, 10);
      const formattedNumber = cleanedDigits.replace(
        /(\d{4})(\d{0,3})(\d{0,3})/,
        (match, p1, p2, p3) => [p1, p2, p3].filter(Boolean).join(' ')
      );

      setAnchorEl(formattedNumber);

      // debounce the API call
      if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
      debounceTimeout.current = setTimeout(() => {
        // pass cleanedDigits (no spaces) or formattedNumber depending on backend expectation
        // Here we pass the digits-only string; if your backend expects spaces, pass formattedNumber.
        const payload = formattedNumber; // <-- choose this or formattedNumber
        buyerCheckin(payload);
      }, 800);
    } else {
      // non-numeric (email/name)
      setAnchorEl(raw);

      if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
      debounceTimeout.current = setTimeout(() => {
        buyerCheckin(raw);
      }, 800);
    }
  };

  // Optional: call this on component unmount to clear pending timeouts
  React.useEffect(() => {
    return () => {
      if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
    };
  }, []);

  const isNotEmptyArray = (arr) =>
    Array.isArray(arr) &&
    arr.length > 0 &&
    !arr.every((item) => Array.isArray(item) && item.length === 0);

  const moxoapis = async (res) => {
    if (isNotEmptyArray(res?.data?.dataForBuyerAdminBinder))
      await Moxoseparationinlisting(
        'dataForVendorAdminBinder',
        res?.data?.dataForBuyerAdminBinder
      ); //1
    if (isNotEmptyArray(res?.data?.dataForABPropertyBinder))
      await Moxoseparationinlisting(
        'dataForBuyerAgentBinder',
        res?.data?.dataForABPropertyBinder
      ); //2
    if (isNotEmptyArray(res?.data?.dataForABBinder))
      await Moxoseparationinlisting(
        'dataForBuyerAgentBinder',
        res?.data?.dataForABBinder
      ); //3
    if (isNotEmptyArray(res?.data?.dataForAddComment))
      Moxoseparationinlisting(
        'dataForAddComment',
        res?.data?.dataForAddComment
      ); //4
    if (isNotEmptyArray(res?.data?.dataForViewContractToDo))
      Moxoseparationinlisting(
        'dataForAddToDoItem',
        res?.data?.dataForViewContractToDo
      ); //5
    if (isNotEmptyArray(res?.data?.dataForProFeedbackToDo))
      Moxoseparationinlisting(
        'dataForAddToDoItem',
        res?.data?.dataForProFeedbackToDo
      ); //6
    if (isNotEmptyArray(res?.data?.dataForIdCheckToDo))
      Moxoseparationinlisting(
        'dataForAddToDoItem',
        res?.data?.dataForIdCheckToDo
      ); //7
    if (isNotEmptyArray(res?.data?.dataForBuyerQuestionToDo))
      Moxoseparationinlisting(
        'dataForAddToDoItem',
        res?.data?.dataForBuyerQuestionToDo
      ); //8
    if (isNotEmptyArray(res?.data?.dataForOnboardSolToDo))
      Moxoseparationinlisting(
        'dataForAddToDoItem',
        res?.data?.dataForOnboardSolToDo
      ); //9
    if (isNotEmptyArray(res?.data?.dataForVendorAck))
      Moxoseparationinlisting('dataForVendorAck', res?.data?.dataForVendorAck); //10
    if (isNotEmptyArray(res?.data?.dataForBuyerAck))
      Moxoseparationinlisting('dataForBuyerAck', res?.data?.dataForBuyerAck); //11
  };

  const signUpHandler = (formData, fromScannedCode = '') => {
    setLoading(true);
    const inputData = {
      userName:
        formData.name.value.charAt(0)?.toUpperCase() +
        formData.name.value?.slice(1)?.trim(),
      surName:
        formData.surname.value.charAt(0).toUpperCase() +
        formData.surname.value.slice(1)?.trim(),
      email: formData.userEmail.value,
      mobileNo: formData.userPhoneNo.value,
      isCheckIn: 1,
      propertyId: propertyid,
      agentId: agencyId,
      userTypeCode: 'Buyer001',
    };
    try {
      postApiCall(SIGNUP_URL, inputData).then((res) => {
        if (res?.data?.status == '1') {
          setLoading(false);
          moxoapis(res);
          if (res?.data?.heading == 'Re-inspection') {
            Swal.fire({
              title: res?.data?.heading ? res?.data?.heading : 'Error',
              text: res?.data?.message,
              showDenyButton: false,
              showCancelButton: false,
              icon: 'warning',
              confirmButtonText: 'Close',
            }).then((result) => {
              if (result.isConfirmed) {
                getListInfo();
                activityfun();
              } else if (result.isDenied) {
                return;
              }
            });
          } else {
            getListInfo();
            setRegister(!register);
            setCheckin(!checkin);
            activityfun();
            setBuyerClicked(false);
          }
        } else {
          setLoading(false);
          Swal.fire({
            title: res?.data?.heading ? res?.data?.heading : 'Error',
            text: res?.data?.message,
            showDenyButton: false,
            showCancelButton: false,
            icon:
              res?.data?.heading == 'Buyer Verification Required'
                ? 'warning'
                : 'error',
            confirmButtonText: 'Close',
          }).then((result) => {
            if (result.isConfirmed) {
            } else if (result.isDenied) {
              return;
            }
          });
        }
      });
    } catch (e) {
      setLoading(false);
      Swal.fire({
        title: 'Error',
        text: 'Check-In Failed!',
        showDenyButton: false,
        showCancelButton: false,
        icon: 'error',
        confirmButtonText: 'Close',
      }).then((result) => {
        if (result.isConfirmed) {
        } else if (result.isDenied) {
          return;
        }
      });
    }
  };

  const Location = ({ size }) => {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M16.0358 2.66706C9.89042 2.64618 4.87086 7.53546 4.67023 13.6555L4.66406 14.0353C4.76621 17.0351 5.78683 19.8946 7.58444 22.2505L8.00662 22.8014C9.72247 24.9831 11.7615 26.8981 14.0511 28.4765L14.6023 28.8476L14.6828 28.9107C15.4675 29.4746 16.5271 29.4746 17.3118 28.9107L17.3788 28.8557C19.1955 27.6775 20.8707 26.2932 22.3714 24.73C25.4222 21.5006 27.261 17.882 27.3304 14.207L27.3306 14.0705C27.3514 7.90955 22.4772 2.87455 16.376 2.67325L16.0358 2.66706ZM16.0295 4.6901C21.0675 4.70733 25.1579 8.73271 25.3098 13.7456L25.3141 14.1876C25.2558 17.2687 23.6425 20.4434 20.9134 23.3323C19.5218 24.7818 17.9616 26.0702 16.2693 27.1661L16.1566 27.2509C16.0654 27.33 15.9302 27.33 15.8391 27.2509L15.7295 27.1681C13.2086 25.5222 10.996 23.4442 9.19308 21.0291C7.74084 19.1257 6.88027 16.85 6.70705 14.476L6.6816 14C6.69871 8.94977 10.7117 4.84679 15.7092 4.69444L16.0295 4.6901ZM15.9957 9.86907C13.6112 9.86907 11.6781 11.8081 11.6781 14.2C11.6781 16.5918 13.6112 18.5308 15.9957 18.5308C18.3802 18.5308 20.3133 16.5918 20.3133 14.2C20.3133 11.8081 18.3802 9.86907 15.9957 9.86907ZM15.9962 11.8922C17.2668 11.8922 18.2968 12.9254 18.2968 14.1998C18.2968 15.4743 17.2668 16.5075 15.9962 16.5075C14.7257 16.5075 13.6957 15.4743 13.6957 14.1998C13.6957 12.9254 14.7257 11.8922 15.9962 11.8922Z"
          fill="#414141"
        />
      </svg>
    );
  };

  const Locationdown = () => {
    return (
      <svg
        width="35"
        height="35"
        viewBox="0 0 35 35"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.5055 23.7282C15.4228 23.6476 15.0689 23.3432 14.7779 23.0596C12.9473 21.3973 9.95112 17.0607 9.03656 14.7909C8.8896 14.4462 8.57857 13.5747 8.55859 13.1091C8.55859 12.6629 8.66132 12.2376 8.86963 11.8317C9.16069 11.3258 9.61868 10.92 10.1594 10.6976C10.5347 10.5544 11.6575 10.332 11.6775 10.332C12.906 10.1096 14.902 9.9873 17.1078 9.9873C19.2094 9.9873 21.1241 10.1096 22.3711 10.2917C22.3911 10.3125 23.7865 10.5349 24.2645 10.7782C25.1376 11.2243 25.6798 12.0958 25.6798 13.0285V13.1091C25.6584 13.7165 25.1162 14.9938 25.0963 14.9938C24.1803 17.1413 21.331 21.3778 19.4377 23.0805C19.4377 23.0805 18.9512 23.56 18.6473 23.7685C18.2107 24.0938 17.6699 24.255 17.1292 24.255C16.5257 24.255 15.9635 24.0729 15.5055 23.7282Z"
          fill="#112347"
        />
      </svg>
    );
  };
  const LocationUp = () => {
    return (
      <svg
        width="35"
        height="35"
        viewBox="0 0 35 35"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.7367 10.514C18.8194 10.5946 19.1733 10.899 19.4643 11.1825C21.2949 12.8449 24.2911 17.1815 25.2056 19.4513C25.3526 19.796 25.6636 20.6675 25.6836 21.1331C25.6836 21.5793 25.5809 22.0046 25.3726 22.4104C25.0815 22.9164 24.6235 23.3222 24.0828 23.5446C23.7075 23.6878 22.5847 23.9102 22.5647 23.9102C21.3362 24.1326 19.3402 24.2549 17.1344 24.2549C15.0328 24.2549 13.118 24.1326 11.8711 23.9505C11.8511 23.9296 10.4557 23.7072 9.97773 23.464C9.10455 23.0178 8.56238 22.1464 8.56238 21.2137V21.1331C8.58378 20.5257 9.12595 19.2483 9.14593 19.2483C10.0619 17.1009 12.9112 12.8644 14.8045 11.1617C14.8045 11.1617 15.291 10.6822 15.5949 10.4737C16.0315 10.1484 16.5723 9.9872 17.113 9.9872C17.7165 9.9872 18.2787 10.1693 18.7367 10.514Z"
          fill="#112347"
        />
      </svg>
    );
  };

  const Mobile = () => {
    return (
      <svg
        width="30"
        height="30"
        viewBox="0 0 20 31"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10 24.6146H10.015M4 29.1596H16C17.6569 29.1596 19 27.8031 19 26.1296V4.91965C19 3.24622 17.6569 1.88965 16 1.88965H4C2.34314 1.88965 1 3.24622 1 4.91965V26.1296C1 27.8031 2.34314 29.1596 4 29.1596Z"
          stroke="#374151"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  };

  const Success = () => {
    return (
      <svg
        width="169"
        height={matchessm ? '15vh' : '20vh'}
        viewBox="0 0 169 169"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M56.6667 84.5L75.2222 103.056L112.333 65.9444M168 84.5C168 130.616 130.616 168 84.5 168C38.3842 168 1 130.616 1 84.5C1 38.3842 38.3842 1 84.5 1C130.616 1 168 38.3842 168 84.5Z"
          stroke="#6C2AD2"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  };

  const Tick = () => {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12 24C18.6275 24 24 18.6275 24 12C24 5.37258 18.6275 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6275 5.37258 24 12 24ZM17.5606 10.0607C18.1464 9.47487 18.1464 8.52513 17.5606 7.93933C16.9749 7.35356 16.0251 7.35356 15.4394 7.93933L10.5 12.8787L8.56067 10.9393C7.97487 10.3536 7.02513 10.3536 6.43933 10.9393C5.85356 11.5251 5.85356 12.4749 6.43933 13.0606L9.43933 16.0606C10.0251 16.6464 10.9749 16.6464 11.5607 16.0606L17.5606 10.0607Z"
          fill="#BDF3AF"
        />
      </svg>
    );
  };
  const [showScanner, setShowScanner] = useState('');
  const [buyerIdInput, setBuyerIdInput] = useState('');
  const [checkInType, setBuyerCheckInType] = useState('Qr Code');
  useEffect(() => {
    setAnchorEl('');
  }, [buyerClicked, checkInType]);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const buyerIdCheckInById = async () => {
    const formattedId = buyerIdInput.trim();

    const userId = /^Buyer/i.test(formattedId)
      ? formattedId
      : /^Vendor/i.test(formattedId)
      ? formattedId
      : /^B/i.test(formattedId)
      ? formattedId.replace(/^B/i, 'Buyer')
      : /^V/i.test(formattedId)
      ? formattedId.replace(/^V/i, 'Vendor')
      : formattedId;

    setLoadingSubmit(true);
    const input = {
      propertyId: propertyid,
      qrCodeValue: '',
      buyerId: userId,
    };

    try {
      const res = await buyerCheckIn(input);
      if (res?.status === 1) {
        setCheckInData(res?.buyerDetails[0]);
        const inputData = {
          userName:
            res?.buyerDetails[0]?.userName?.charAt(0)?.toUpperCase() +
            res?.buyerDetails[0]?.userName?.slice(1)?.trim(),
          surName:
            res?.buyerDetails[0]?.userSurName?.charAt(0)?.toUpperCase() +
            res?.buyerDetails[0]?.userSurName?.slice(1)?.trim(),
          email: res?.buyerDetails[0]?.userEmail,
          mobileNo: res?.buyerDetails[0]?.userPhone,
          isCheckIn: 1,
          propertyId: propertyid,
          agentId: agencyId,
          userTypeCode: 'Buyer001',
        };
        try {
          postApiCall(SIGNUP_URL, inputData).then((res) => {
            if (res?.data?.status == '1') {
              setLoadingSubmit(false);
              setBuyerIdInput('');
              moxoapis(res);
              if (res?.data?.heading == 'Re-inspection') {
                Swal.fire({
                  title: res?.data?.heading ? res?.data?.heading : 'Error',
                  text: res?.data?.message,
                  showDenyButton: false,
                  showCancelButton: false,
                  icon: 'warning',
                  confirmButtonText: 'Close',
                }).then((result) => {
                  if (result.isConfirmed) {
                    getListInfo();
                    activityfun();
                    setAnchorEl('');
                  } else if (result.isDenied) {
                    setLoadingSubmit(false);
                    return;
                  }
                });
              } else {
                getListInfo();
                setRegister(!register);
                setCheckin(!checkin);
                activityfun();
                setAnchorEl('');
                setLoadingSubmit(false);
              }
            } else {
              setLoadingSubmit(false);
              Swal.fire({
                title: res?.data?.heading ? res?.data?.heading : 'Error',
                text: res?.data?.message,
                showDenyButton: false,
                showCancelButton: false,
                icon:
                  res?.data?.heading == 'Buyer Verification Required'
                    ? 'warning'
                    : 'error',
                confirmButtonText: 'Close',
              }).then((result) => {
                if (result.isConfirmed) {
                } else if (result.isDenied) {
                  setLoadingSubmit(false);
                  return;
                }
              });
            }
          });
        } catch (e) {
          setLoadingSubmit(false);
          Swal.fire({
            title: 'Error',
            text: 'Check-In Failed!',
            showDenyButton: false,
            showCancelButton: false,
            icon: 'error',
            confirmButtonText: 'Close',
          }).then((result) => {
            if (result.isConfirmed) {
            } else if (result.isDenied) {
              return;
            }
          });
        }
      } else {
        setLoadingSubmit(false);
        Swal.fire({
          title: res?.heading || 'Error',
          text: res?.message || 'An unexpected error occurred.',
          icon: 'error',
          confirmButtonText: 'Close',
        });
      }
    } catch (error) {
      setLoadingSubmit(false);
      Swal.fire({
        title: 'Error',
        text: 'Check-In Failed!',
        icon: 'error',
        confirmButtonText: 'Close',
      });
    } finally {
    }
  };
  const [sortIcon, setSortIcon] = useState(<Sortcoloricon />);
  const handleFilterClick = () => {
    setFilter(!filter);
  };

  const handleSortClick = () => {
    setIsSortClicked(!isSortClicked);
    setSortIcon(isSortClicked ? <Sortcoloricon /> : <SortUpcoloricon />);
    activityFilter(activity);
  };

  const [isMapClicked, setIsMapClicked] = useState(false);
  const handleMapClick = () => {
    setIsMapClicked(!isMapClicked);
  };

  const menuProps1 = {
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'center',
    },
    transformOrigin: {
      vertical: 'bottom',
      horizontal: 'center',
    },
  };

  const menuProps2 = {
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'center',
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'center',
    },
  };

  const [readyArr] = React.useState([
    { key: 0, label: 'Any' },
    { key: 1, label: '25' },
    { key: 2, label: '50' },
    { key: 3, label: '75' },
  ]);
  const [noOfOfferArr] = React.useState([
    { key: 0, label: 'Any' },
    { key: 1, label: '5' },
    { key: 2, label: '10' },
    { key: 3, label: '20' },
    { key: 4, label: '30' },
    { key: 5, label: '40' },
  ]);
  const [expArr] = React.useState([
    { key: 0, label: 'Any' },
    { key: 1, label: 'A' },
    { key: 2, label: 'B' },
    { key: 3, label: 'C' },
    { key: 4, label: 'D' },
  ]);
  const [profileArr] = React.useState([
    { key: 0, label: 'Any' },
    { key: 'FHB', label: 'First time buyer' },
    { key: 'INV', label: 'Investor' },
    { key: 'UpSize', label: 'Up Sizer' },
    { key: 'DownSize', label: 'Down Sizer' },
  ]);

  const [selectedReadiness, setselectedReadiness] = useState([]);
  const [selected66w, setselected66w] = useState([]);
  const [selectedBuyerLocation, setselectedBuyerLocation] = useState([]);
  const [selectedProfile, setselectedProfile] = useState([]);
  const [selectedNoOfOffer, setselectedNoOfOffer] = useState([]);
  const [selectedExperience, setselectedExperience] = useState([]);
  const [menuCliked, setMenuClicked] = useState(false);
  const [searchClicked, setSearchClicked] = useState(false);

  const handleReadiness = (event, newFormats) => {
    setselectedReadiness(newFormats);
  };

  const handle66w = (event, newFormats) => {
    setselected66w(newFormats);
  };
  const handleBuyerLoaction = (event, newFormats) => {
    setselectedBuyerLocation(newFormats);
  };
  const handleProfile = (event, newFormats) => {
    setselectedProfile(newFormats);
  };
  const handleNoOfOffer = (event, newFormats) => {
    setselectedNoOfOffer(newFormats);
  };
  const handleExperience = (event, newFormats) => {
    setselectedExperience(newFormats);
  };
  // Agent buyer register Filter
  const filterResults = () => {
    let filtered = subFilter || [];
    // Offer Price
    filtered = filtered.filter((item) => {
      const offerPrice = Number(item?.buyerOfferPrice);
      if (isNaN(offerPrice)) return false;
      return (
        offerPrice >= Number(slidervalue[0]) &&
        offerPrice <= Number(slidervalue[1])
      );
    });
    // Buyer Readiness
    if (selectedReadiness && selectedReadiness !== 'Any') {
      const readinessValue = Number(selectedReadiness);
      filtered = filtered.filter((item) => {
        const value = parseFloat(item?.buyerDetails?.rediness);
        return !isNaN(value) && value > readinessValue;
      });
    }
    // 66w
    if (selected66w === 'Yes' || selected66w === 'No') {
      const is66SignedExpected = selected66w === 'Yes' ? 1 : 0;
      filtered = filtered.filter((item) => {
        const actualValue = Number(item?.buyerDetails?.is66Signed);
        return actualValue === is66SignedExpected;
      });
    }
    // Profile
    if (
      typeof selectedProfile === 'string' &&
      selectedProfile.trim() !== '' &&
      selectedProfile !== 'Any'
    ) {
      filtered = filtered.filter(
        (item) =>
          String(item?.buyerDetails?.profile || '').toLowerCase() ===
          selectedProfile.trim().toLowerCase()
      );
    }

    // Number of Offers
    if (selectedNoOfOffer && selectedNoOfOffer !== 'Any') {
      const minOffers = Number(selectedNoOfOffer); // "5" → 5
      filtered = filtered.filter(
        (item) => Number(item?.buyerDetails?.noOfOffers || 0) >= minOffers
      );
    }
    // Experience
    if (
      typeof selectedExperience === 'string' &&
      selectedExperience.trim() !== '' &&
      selectedExperience !== 'Any'
    ) {
      const experienceFilter = String(selectedExperience).trim().toLowerCase();
      filtered = filtered.filter((item) => {
        const exp = item?.buyerDetails?.exp;
        return exp && String(exp).toLowerCase().includes(experienceFilter);
      });
    }
    setMainFilter(filtered);
    setFilter((prev) => !prev);
  };

  const buttonStyles = {
    fontSize: '12px',
    fontFamily: 'poppins',
    fontWeight: 400,
    lineHeight: '18px',
    backgroundColor: 'rgba(108, 42, 210, 0.1)',
    height: '52px',
    width: '140px',
    borderRadius: '5px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: '#6C2AD2',
  };

  const [checkInSuggestion, setCheckInSuggestion] = useState();

  const swiperRef = React.useRef(null);

  const BuyerPrefill = (data) => {
    const inputData = {
      contactValue: data,
      propertyId: propertyid,
    };
    setFoundData(true);

    postApiCall(BUYER_CHECK_IN, inputData).then(async (res) => {
      if (res?.data?.status == 1) {
        setCheckInSuggestion(res?.data);
      } else {
        setCheckInSuggestion('');
      }
    });
  };

  const handleSuggestionClick = (dataItem) => {
    setFormValues({
      name: {
        value: dataItem.userName || '',
        error: false,
        errorMessage: 'Please enter the firstname',
      },
      surname: {
        value: dataItem.userSurName || '',
        error: false,
        errorMessage: 'Please enter the surname',
      },
      userEmail: {
        value: dataItem.userEmail || '',
        error: false,
        errorMessage: 'Please enter the email address',
      },
      userPhoneNo: {
        value: dataItem.userPhone || '',
        error: false,
        errorMessage: 'Please enter the phone number',
      },
    });

    setNameAnchorEl('');
    setSurnameAnchorEl('');
    setEmailAnchorEl('');
    setMobileAnchorEl('');
  };

  useEffect(() => {
    if (loading || loadingSubmit) {
      document.body.style.pointerEvents = 'none';
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    };
  }, [loading, loadingSubmit]);

  const showArrows = checkInData?.userData?.length > 1;
  const totalSlides = checkInData?.userData?.length ?? 0;

  return (
    <Card
      variant="outlined"
      sx={[
        !matchessm && statusCard,
        { borderRadius: matchessm ? '10px' : '5px' },
      ]}
      style={{
        display: 'flex',
        flexDirection: 'column',
        overflowX: 'hidden',
      }}
    >
      <Stack
        direction={'row'}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          overflowX: 'auto',
          padding: matchessm && '20px',
        }}
      >
        {!menuCliked && (
          <Grid item style={{ flexShrink: 0 }}>
            <CardHeaderContainer
              title="Buyer Register"
              icon={buyerRegistration}
            />
          </Grid>
        )}
        {matchessm ? (
          <Grid
            item
            sx={{ display: 'flex', flexGrow: 1, justifyContent: 'flex-end' }}
          >
            {!menuCliked && (
              <>
                <Box
                  width={41}
                  height={41}
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  sx={{ border: '1px solid #F0F0F0', borderRadius: '5px' }}
                  onClick={() => {
                    setPortraitMode((prev) => !prev);
                  }}
                >
                  <ToggeleIconViewType />
                </Box>
                <Box
                  borderRadius="50%"
                  width={41}
                  height={41}
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  sx={{ border: '1px solid #F0F0F0', marginLeft: '10px' }}
                  onClick={() => {
                    setMenuClicked((prev) => !prev);
                  }}
                >
                  <Propertymenu />
                </Box>
              </>
            )}
            {menuCliked && !searchClicked && (
              <Stack
                direction={'row'}
                alignItems={'center'}
                spacing={1}
                flexGrow={1}
                justifyContent={'flex-end'}
              >
                <IconButton
                  aria-label="search"
                  sx={{
                    border: '1px solid #F0F0F0',
                    borderRadius: '5px',
                    width: '42px',
                    height: '42px',
                  }}
                  onClick={() => {
                    setSearchClicked((prev) => !prev);
                  }}
                >
                  <SearchIcons />
                </IconButton>
                {!vendorside &&
                  props?.profileDetails?.PropertyDetails?.property?.status ===
                    'Publish' && (
                    <Box
                      component={
                        props?.profileDetails?.PropertyDetails?.timerStatus ==
                        'Start'
                          ? IconButton
                          : ''
                      }
                      onClick={() => {
                        if (
                          props?.profileDetails?.PropertyDetails?.timerStatus ==
                          'Start'
                        ) {
                          setRegister(true);
                          setFormValues(formValuesempty);
                          setBuyerCheckInType('Qr Code');
                        }
                      }}
                      sx={{
                        border: '1px solid #F0F0F0',
                        height: '42px',
                        borderRadius: '5px',
                        padding: '0px 10px',
                        display: 'flex',
                        alignItems: 'center',
                        flexShrink: 0,
                        cursor:
                          props?.profileDetails?.PropertyDetails
                            ?.timerStatus !== 'Start'
                            ? 'not-allowed'
                            : 'pointer',
                      }}
                    >
                      <Typography
                        color="#666666"
                        sx={{
                          fontFamily: 'Poppins !important',
                          fontStyle: 'normal !important',
                          fontWeight: '400 !important',
                          fontSize: '14px !important',
                          display: 'flex',
                          alignItems: 'center',
                        }}
                      >
                        {' '}
                        <AddbuyerPlusIcon />
                        &nbsp; Add
                      </Typography>
                    </Box>
                  )}

                <Stack direction={'row'} alignItems={'center'} spacing={1}>
                  <Typography
                    onClick={handleFilterClick}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      cursor: 'pointer',
                    }}
                  >
                    {filter ? <Filtercoloricon /> : <Filtercoloricon />}
                  </Typography>
                  <Typography
                    onClick={handleSortClick}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      cursor: 'pointer',
                    }}
                  >
                    {sortIcon}
                  </Typography>
                </Stack>
                <Box
                  borderRadius="50%"
                  width={41}
                  height={41}
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  sx={{ border: '1px solid #F0F0F0' }}
                  onClick={() => {
                    setMenuClicked((prev) => !prev);
                  }}
                >
                  <Invertedmenu />
                </Box>
              </Stack>
            )}
            {menuCliked && searchClicked && (
              <Box
                component="form"
                border={1}
                onSubmit={(e) => e.preventDefault()}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: '#F8F8F8',
                  border: '1px solid #F0F0F0',
                  borderRadius: '30px',
                  height: '41px',
                  width: '100%',
                }}
              >
                <InputBase
                  sx={{
                    ml: 1,
                    width: '100%',
                    '& ::placeholder': {
                      color: '#66666  !important',
                      fontSize: '14px',
                      fontWeight: 400,
                      fontFamily: 'poppins',
                      opacity: 0.9,
                    },

                    fontSize: '14px',
                    fontWeight: 400,
                    fontFamily: 'poppins',
                  }}
                  placeholder="Search here"
                  inputProps={{
                    'aria-label': 'Search here',
                  }}
                  value={searchValue}
                  onChange={(e) => {
                    setSearchValue(e.target.value);
                    searchFilter(e.target.value);
                  }}
                />
                <IconButton
                  sx={{ p: '10px', paddingRight: '20px' }}
                  aria-label="cancel"
                  onClick={() => {
                    setSearchValue('');
                    searchFilter('');
                    setSearchClicked(false);
                  }}
                >
                  <Cancelicon />
                </IconButton>
              </Box>
            )}
          </Grid>
        ) : (
          <Stack direction={'row'} sx={{ gap: '15px' }}>
            <Box
              component="form"
              onSubmit={(e) => e.preventDefault()}
              sx={{
                display: 'flex',
                alignItems: 'center',
                backgroundColor: '#F8F8F8',
                border: '1px solid #F0F0F0',
                borderRadius: '30px',
                height: '41px',
                width: '266px',
              }}
            >
              <IconButton
                disabled
                sx={{ paddingLeft: '20px' }}
                aria-label="search"
              >
                <img alt="searchIcon" src={searchIcon} />
              </IconButton>
              <InputBase
                sx={{
                  ml: 1,
                  flex: 1,
                  '& ::placeholder': {
                    color: '#666666',
                    fontSize: '14px',
                    fontWeight: 400,
                    fontFamily: 'poppins',
                    opacity: 0.9,
                  },
                  fontSize: '14px',
                  fontWeight: 400,
                  fontFamily: 'poppins',
                }}
                placeholder="Search here"
                value={searchValue}
                inputProps={{
                  'aria-label': 'Search here',
                }}
                onChange={(e) => {
                  setSearchValue(e.target.value);
                  searchFilter(e.target.value);
                }}
              />

              {searchValue.length > 0 && (
                <IconButton
                  size="small"
                  onClick={() => {
                    setSearchValue('');
                    searchFilter('');
                  }}
                >
                  <CloseRoundedIcon fontSize="small" />
                </IconButton>
              )}
            </Box>
            {!vendorside &&
              props?.profileDetails?.PropertyDetails?.property?.status ===
                'Publish' && (
                <Box
                  component={
                    props?.profileDetails?.PropertyDetails?.timerStatus ==
                    'Start'
                      ? IconButton
                      : ''
                  }
                  onClick={() => {
                    if (
                      props?.profileDetails?.PropertyDetails?.timerStatus ==
                      'Start'
                    ) {
                      setRegister(true);
                      setFormValues(formValuesempty);
                      setBuyerCheckInType('Qr Code');
                    }
                  }}
                  sx={{
                    border: '1px solid #F0F0F0',
                    height: '42px',
                    borderRadius: '5px',
                    padding: '0px 10px',
                    display: 'flex',
                    alignItems: 'center',
                    flexShrink: 0,
                    cursor:
                      props?.profileDetails?.PropertyDetails?.timerStatus !==
                      'Start'
                        ? 'not-allowed'
                        : 'pointer',
                  }}
                >
                  <Typography
                    color="#666666"
                    sx={{
                      fontFamily: 'Poppins !important',
                      fontStyle: 'normal !important',
                      fontWeight: '400 !important',
                      fontSize: '14px !important',
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    {' '}
                    <AddbuyerPlusIcon />
                    &nbsp; Add Buyer
                  </Typography>
                </Box>
              )}
            <Typography
              style={{
                display: 'flex',
                alignItems: 'center',
                flexShrink: 0,
                gap: '15px',
              }}
            >
              <Typography
                sx={{ ...poppins500, fontSize: '12px', color: '#A4A3A3' }}
              >
                Sort By: &nbsp;
              </Typography>
              <Typography>
                <Select
                  sx={{
                    border: '1px solid #F0F0F0',
                    alignItems: 'center',
                    ...poppins400,
                    fontSize: '14px',
                    boxShadow: '0px 1px 4px 0px #00000026',
                    color: '#666666',
                    '.MuiOutlinedInput-notchedOutline': { border: 0 },
                    height: '100%',
                    borderRadius: '5px',
                  }}
                  size="small"
                  value={activity}
                  inputProps={{ 'aria-label': 'Without label' }}
                  MenuProps={{
                    anchorOrigin: {
                      vertical: 'center',
                      horizontal: 'right',
                    },
                    transformOrigin: {
                      vertical: 'center',
                      horizontal: 'left',
                    },
                    getContentAnchorEl: null,
                  }}
                >
                  <MenuItem
                    disabled
                    value={'Activity'}
                    color="#666666"
                    sx={{ ...poppins400 }}
                    onClick={(e) => {
                      setActivity('Activity');
                      activityFilter('Activity');
                    }}
                  >
                    Default
                  </MenuItem>
                  <MenuItem
                    onClick={(e) => {
                      setActivity('Interest');
                      activityFilter('Interest');
                    }}
                    value={'Interest'}
                    color="#666666"
                    sx={{ ...poppins400 }}
                  >
                    Interest
                  </MenuItem>
                  <MenuItem
                    onClick={(e) => {
                      setActivity('Name');
                      activityFilter('Name');
                    }}
                    value={'Name'}
                    color="#666666"
                    sx={{ ...poppins400 }}
                  >
                    Name
                  </MenuItem>
                  {!vendorside && (
                    <MenuItem
                      onClick={(e) => {
                        setActivity('Readiness');
                        activityFilter('Readiness');
                      }}
                      value={'Readiness'}
                      color="#666666"
                      sx={{ ...poppins400 }}
                    >
                      Readiness
                    </MenuItem>
                  )}
                  <MenuItem
                    onClick={(e) => {
                      setActivity('66W');
                      activityFilter('66W');
                    }}
                    value={'66W'}
                    color="#666666"
                    sx={{ ...poppins400 }}
                  >
                    s66W
                  </MenuItem>
                  <MenuItem
                    onClick={(e) => {
                      setActivity('Offer');
                      activityFilter('Offer');
                    }}
                    value={'Offer'}
                    color="#666666"
                    sx={{ ...poppins400 }}
                  >
                    Offer
                  </MenuItem>
                  "
                  <MenuItem
                    onClick={(e) => {
                      setActivity('Numberofoffers');
                      activityFilter('Numberofoffers');
                    }}
                    value={'Numberofoffers'}
                    color="#666666"
                    sx={{ ...poppins400 }}
                  >
                    Number of offers
                  </MenuItem>
                  <MenuItem
                    onClick={(e) => {
                      setActivity('Buyerrating');
                      activityFilter('Buyerrating');
                    }}
                    value={'Buyerrating'}
                    color="#666666"
                    sx={{ ...poppins400 }}
                  >
                    Buyer rating
                  </MenuItem>
                  <MenuItem
                    onClick={(e) => {
                      setActivity('Buyerexperience');
                      activityFilter('Buyerexperience');
                    }}
                    value={'Buyerexperience'}
                    color="#666666"
                    sx={{ ...poppins400 }}
                  >
                    Buyer experience
                  </MenuItem>
                  <MenuItem
                    onClick={(e) => {
                      setActivity('Offer date');
                      activityFilter('Offer date');
                    }}
                    value={'Offer date'}
                    color="#666666"
                    sx={{ ...poppins400 }}
                  >
                    Offer date
                  </MenuItem>
                </Select>
              </Typography>
            </Typography>
            <Stack direction={'row'} alignItems={'center'} spacing={1}>
              <Typography
                onClick={handleFilterClick}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  cursor: 'pointer',
                }}
              >
                {filter ? <Filtercoloricon /> : <Filtercoloricon />}
              </Typography>
              <Typography
                onClick={handleSortClick}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  cursor: 'pointer',
                }}
              >
                {sortIcon}
              </Typography>
            </Stack>
          </Stack>
        )}
      </Stack>

      <Typography style={{ paddingTop: '20px' }}>
        {!vendorside && (
          <div
            style={{
              display: 'flex',
              fontFamily: 'Poppins',
              fontWeight: 400,
              color: '#000000',
              fontSize: '14px',
              cursor: 'pointer',
              paddingLeft: matchessm ? '20px' : '0px',
            }}
            onClick={() => setShowEngagedTable((prev) => !prev)}
          >
            Engaged
            {props?.profileDetails?.BuyerRegisterDetailsCount !== 0 &&
              `(${props?.profileDetails?.BuyerRegisterDetailsCount})`}{' '}
            {showEngagedTable ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
          </div>
        )}
        {!vendorside && showEngagedTable && (
          <EnhancedTable
            headCells={headCells}
            tableData={mainFilter}
            onClick={props.onClick}
            id={props.id}
            getListInfo={props?.getListInfo}
            vendorDatas={vendorDatas}
            address={address}
            onShowChat={onShowChat}
            vendorside={vendorside}
            propertyDetails={props?.profileDetails}
            propertyId={propertyId}
            publishwinner={publishwinner}
            setSelbuyerId={setSelbuyerId}
            buyerpropertylist={buyerpropertylist}
            propertyUniqueId={propertyUniqueId}
            getdata={getdata}
            userTypeValue={userTypeValue}
            portraitMode={portraitMode}
            setIsPipelineCat={setIsPipelineCat}
            setPipelineCat={setPipelineCat}
            setPipelineId={setPipelineId}
            setIsAppraisal={setIsAppraisal}
            {...props}
          />
        )}
        <Typography style={{ paddingTop: '20px' }}>
          {!vendorside && (
            <div
              style={{
                fontFamily: 'Poppins',
                fontWeight: 400,
                color: '#000000',
                display: 'flex',
                alignItems: 'center',
                fontSize: '14px',
                cursor: 'pointer',
                paddingLeft: matchessm ? '20px' : '0px',
              }}
              onClick={() => setShowConnectedTable((prev) => !prev)}
            >
              Connected{' '}
              {props?.profileDetails?.BuyerRegisterDetailsConnectedCount !==
                0 &&
                `(${props?.profileDetails?.BuyerRegisterDetailsConnectedCount})`}{' '}
              {showConnectedTable ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
            </div>
          )}
          {!vendorside && showConnectedTable && (
            <EnhancedTable
              headCells={headCells}
              tableData={connectedData}
              onClick={props.onClick}
              id={props.id}
              getListInfo={props?.getListInfo}
              address={address}
              onShowChat={onShowChat}
              vendorside={vendorside}
              propertyDetails={props?.profileDetails}
              propertyId={propertyId}
              publishwinner={publishwinner}
              setSelbuyerId={setSelbuyerId}
              buyerpropertylist={buyerpropertylist}
              propertyUniqueId={propertyUniqueId}
              getdata={getdata}
              userTypeValue={userTypeValue}
              portraitMode={portraitMode}
              setIsPipelineCat={setIsPipelineCat}
              setPipelineCat={setPipelineCat}
              setPipelineId={setPipelineId}
              setIsAppraisal={setIsAppraisal}
              vendorDatas={vendorDatas}
              {...props}
            />
          )}
        </Typography>
        <Typography style={{ paddingTop: '20px' }}>
          {!vendorside && (
            <div
              style={{
                display: 'flex',
                fontFamily: 'Poppins',
                fontWeight: 400,
                color: '#000000',
                fontSize: '14px',
                cursor: 'pointer',
                paddingLeft: matchessm ? '20px' : '0px',
              }}
              onClick={() => setShowPendingTable((prev) => !prev)}
            >
              Pending{' '}
              {props?.profileDetails?.buyerRegisterDetailsPendingCount !== 0 &&
                `(${props?.profileDetails?.buyerRegisterDetailsPendingCount})`}{' '}
              {showPendingTable ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
            </div>
          )}
          {!vendorside && showPendingTable && (
            <EnhancedTable
              headCells={headCells}
              tableData={pendingData}
              onClick={props.onClick}
              id={props.id}
              getListInfo={props?.getListInfo}
              address={address}
              onShowChat={onShowChat}
              vendorside={vendorside}
              propertyDetails={props?.profileDetails}
              propertyId={propertyId}
              publishwinner={publishwinner}
              setSelbuyerId={setSelbuyerId}
              buyerpropertylist={buyerpropertylist}
              propertyUniqueId={propertyUniqueId}
              getdata={getdata}
              userTypeValue={userTypeValue}
              portraitMode={portraitMode}
              setIsPipelineCat={setIsPipelineCat}
              setPipelineCat={setPipelineCat}
              setPipelineId={setPipelineId}
              setIsAppraisal={setIsAppraisal}
              pendingTable={true}
              vendorDatas={vendorDatas}
              showPendingTable={showPendingTable}
              {...props}
            />
          )}
        </Typography>
        {vendorside && (
          <EnhancedTable
            headCells={headCellsvendor}
            tableData={mainFilter}
            onClick={props.onClick}
            id={props.id}
            getListInfo={props?.getListInfo}
            vendorDatas={vendorDatas}
            address={address}
            onShowChat={onShowChat}
            vendorside={vendorside}
            propertyDetails={props?.profileDetails}
            stage={stage}
            propertyId={propertyId}
            getdata={getdata}
            portraitMode={portraitMode}
            setIsSwalOpen={setIsSwalOpen}
            setVendorGeneratePdf={setVendorGeneratePdf}
          />
        )}
      </Typography>

      <Dialog
        fullScreen
        open={register}
        onClose={() => setRegister(!register)}
        container={() => document.getElementById('dialog-root')}
        PaperProps={{
          sx: {
            width: '100vw',
            height: '100vh',
            maxWidth: '100vw',
            maxHeight: '100vh',
            borderRadius: 0,
          },
        }}
      >
        <ScaledDialogContent>
          <>
            <Typography
              display={'flex'}
              justifyContent={'space-between'}
              padding={'5px 15px'}
              sx={{ backgroundColor: '#F9F9F9', alignItems: 'center' }}
            >
              <img
                src={dashboardLogo}
                alt="logo"
                onClick={
                  !loadingSubmit && !loading
                    ? () => history.push('/dashboard')
                    : undefined
                }
                style={{
                  cursor: loadingSubmit || loading ? 'not-allowed' : 'pointer',
                }}
              />
              <IconButton
                onClick={() => {
                  setRegister(!register);
                  setAnchorEl('');
                  setBuyerIdInput('');
                  setBuyerClicked(false);
                }}
                disabled={loadingSubmit || loading}
              >
                <CloseRoundedIcon style={{ fontSize: '2.3rem' }} />
              </IconButton>
            </Typography>
            <Typography
              display={'flex'}
              alignItems={'flex-start'}
              justifyContent={'center'}
              sx={{
                fontSize: matches700 ? '14px' : '20px',
                fontFamily: 'poppins',
                fontWeight: 400,
                paddingTop: '1vh',
                lineHeight: '30px',
              }}
            >
              {matchessm ? (
                <Box
                  sx={{
                    width: '30px',
                    height: '30px',
                    padding: '5px',
                  }}
                >
                  <Location size={'25px'} />
                </Box>
              ) : (
                <Location size={'32px'} />
              )}

              <Typography
                display="flex"
                alignItems="center"
                sx={{
                  fontSize: matches700 ? '14px' : '20px',
                  fontFamily: 'Poppins',
                  fontWeight: 400,
                  lineHeight: '30px',
                  overflow: 'hidden',
                  textAlign: 'center',
                  maxWidth: '80%',
                }}
              >
                {
                  props?.profileDetails?.PropertyDetails?.propertyAddress
                    ?.streetName
                }
              </Typography>
              <IconButton
                onClick={() => {
                  setQuickswitch(!quickswitch);
                }}
                sx={{ padding: '0px' }}
              >
                {' '}
                {!quickswitch ? <Locationdown /> : <LocationUp />}
              </IconButton>
            </Typography>
            <Typography
              display={'flex'}
              alignItems={'flex-start'}
              justifyContent={'center'}
              sx={{
                fontSize: '20px',
                fontFamily: 'poppins',
                fontWeight: 700,
                lineHeight: '30px',
                paddingTop: '2vh',
                textAlign: 'center',
              }}
            >
              Buyer Check-In
            </Typography>
            <Stack
              sx={{
                display: 'flex',
                justifyContent: 'center',
                width: '100%',
                alignSelf: 'center',
                margin: matchessm ? '0px' : '0 20px',
              }}
            >
              <FormControl sx={{ alignSelf: 'center', padding: '20px 0px' }}>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                >
                  <FormControlLabel
                    value="Qr Code"
                    control={<Radio disabled={loading || loadingSubmit} />}
                    label={
                      <Typography
                        sx={{
                          fontSize: '14px',
                          fontFamily: 'poppins',
                          fontWeight: 'bold',
                          lineHeight: '17x',
                        }}
                      >
                        QR Code
                      </Typography>
                    }
                    onClick={(e) => {
                      if (loading || loadingSubmit) return;
                      setBuyerCheckInType(e.target.value);
                      setBuyerIdInput('');
                    }}
                    checked={checkInType === 'Qr Code'}
                  />
                  <FormControlLabel
                    value="Buyer Id"
                    onClick={(e) => {
                      if (loading || loadingSubmit) return;
                      setBuyerCheckInType(e.target.value);
                    }}
                    control={<Radio disabled={loading || loadingSubmit} />}
                    label={
                      <Typography
                        sx={{
                          fontSize: '14px',
                          fontFamily: 'poppins',
                          fontWeight: 'bold',
                          lineHeight: '17x',
                        }}
                      >
                        Buyer ID
                      </Typography>
                    }
                    checked={checkInType === 'Buyer Id'}
                  />
                  <FormControlLabel
                    value="Form"
                    onClick={(e) => {
                      if (loading || loadingSubmit) return;
                      setBuyerCheckInType(e.target.value);
                      setBuyerIdInput('');
                      setFormValues({
                        ...formValues,
                        ['name']: {
                          ...formValues['name'],
                          value: '',
                          error: false,
                        },
                        ['surname']: {
                          ...formValues['surname'],
                          value: '',
                          error: false,
                        },
                        ['userEmail']: {
                          ...formValues['userEmail'],
                          value: '',
                          error: false,
                        },
                        ['userPhoneNo']: {
                          ...formValues['userPhoneNo'],
                          value: '',
                          error: false,
                        },
                      });
                    }}
                    control={<Radio disabled={loading || loadingSubmit} />}
                    label={
                      <Typography
                        sx={{
                          fontSize: '14px',
                          fontFamily: 'poppins',
                          fontWeight: 'bold',
                          lineHeight: '17x',
                        }}
                      >
                        Form
                      </Typography>
                    }
                    checked={checkInType === 'Form'}
                  />
                </RadioGroup>
              </FormControl>
            </Stack>

            {checkInType === 'Qr Code' && (
              <Stack>
                <Typography
                  sx={{ textAlign: 'center', paddingTop: '1vh' }}
                  display={'flex'}
                  flexDirection={'column'}
                  alignItems={'center'}
                >
                  {showScannerloader ? (
                    <Grid
                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        flexDirection: 'column',
                        alignItems: 'center',
                        width: '100%',
                        paddingTop: '5%',
                      }}
                    >
                      <img
                        alt="Logo"
                        src={Loading}
                        className="loaderImage"
                        style={{ height: '100px', width: '100px' }}
                      />
                    </Grid>
                  ) : showScanner ? (
                    <div
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        setShowScanner(!showScanner);
                      }}
                    >
                      <QRCodeScannerComponent
                        showScanner={showScanner}
                        setShowScanner={setShowScanner}
                        propertyId={propertyid}
                        setCheckin={setCheckin}
                        setRegister={setRegister}
                        checkin={checkin}
                        register={register}
                        setFormValues={setFormValues}
                        formValues={formValues}
                        getListInfo={props?.getListInfo}
                        moxoapis={moxoapis}
                        agencyId={agencyId}
                        setCheckInIndex={setCheckInIndex}
                        activityfun={activityfun}
                        setCheckInData={setCheckInData}
                        setShowScannerloader={setShowScannerloader}
                      />
                    </div>
                  ) : (
                    <img
                      src={qr}
                      alt="qr"
                      style={{
                        height: matchessm ? '15vh' : '20vh',
                        cursor: 'pointer',
                      }}
                      onClick={() => setShowScanner(true)}
                    />
                  )}

                  <Typography
                    sx={{
                      fontSize: '11px',
                      fontFamily: 'poppins',
                      fontWeight: 400,
                      lineHeight: '17x',
                      paddingTop: '1vh',
                    }}
                  >
                    {showScannerloader
                      ? 'Fetching Details'
                      : 'Scan Buyer QR or license'}
                  </Typography>
                </Typography>
                <Stack
                  alignItems={'center'}
                  sx={{
                    position: 'absolute',
                    bottom: '20px',
                    left: '48%',
                    display: matches700 && 'none',
                  }}
                >
                  <Typography
                    onClick={() => {
                      setRegister(!register);
                    }}
                    className="bottomicon"
                  >
                    <Category width={28} height={28} className="home" />
                  </Typography>
                  <Typography
                    onClick={() => {
                      setRegister(!register);
                    }}
                    sx={{
                      fontFamily: 'poppins',
                      fontSize: '14px',
                      color: '#9A9A9F',
                      lineHeight: '14px',
                      paddingTop: '5px',
                      cursor: 'pointer',
                    }}
                  >
                    Home
                  </Typography>
                </Stack>
              </Stack>
            )}

            {checkInType === 'Buyer Id' && (
              <>
                <Stack
                  direction={matchessm ? 'column' : 'row'}
                  sx={{
                    display: 'flex',
                    placeContent: 'center',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: 'opx 30px',
                    marginTop: '20px',
                  }}
                  gap={matchessm ? 1 : 5}
                >
                  <Stack>
                    <TextField
                      value={buyerIdInput}
                      rows={4}
                      variant="standard"
                      autoFocus
                      sx={{
                        color: '#000000',
                        borderRadius: '5px',
                        padding: '5px',
                        border: '1px solid #F0F0F0',
                        display: 'flex',
                        justifyContent: 'center',
                        width: '300px',
                      }}
                      placeholder="Buyer Unique ID"
                      type="text"
                      name="name"
                      onKeyDown={(e) => {
                        if (e.key === 'Enter' && buyerIdInput != '') {
                          setLoadingSubmit(true);
                          setCheckInIndex('2');
                          buyerIdCheckInById();
                        }
                      }}
                      inputProps={{ style: { fontFamily: 'poppins' } }}
                      InputProps={{ disableUnderline: true }}
                      onChange={(e) => setBuyerIdInput(e.target.value)}
                    />
                  </Stack>

                  <Stack
                    direction="row"
                    alignItems="center"
                    spacing={1}
                    sx={{
                      width: 'auto',
                      flexShrink: 0,
                      position: 'relative',
                      minWidth: 'fit-content',
                    }}
                  >
                    <Button
                      variant="outlined"
                      onClick={() => {
                        setCheckInIndex('2');
                        buyerIdCheckInById();
                      }}
                      style={{
                        padding: '10px 39px',
                        minWidth: '120px',
                        height: '41px',
                        fontSize: '14px',
                        fontWeight: '400',
                        fontFamily: 'Poppins',
                        borderRadius: '5px',
                        cursor: buyerIdInput === '' ? 'not-allowed' : 'pointer',
                        color: buyerIdInput === '' ? '#A9A9A9' : '#FFFFFF',
                        background: buyerIdInput === '' ? '#E0E0E0' : '#4CA4D6',
                      }}
                      disabled={loadingSubmit || buyerIdInput == ''}
                    >
                      Submit
                    </Button>

                    {loadingSubmit && (
                      <img
                        alt="Logo"
                        src={Loading}
                        className="loaderImage"
                        style={{
                          height: '40px',
                          width: '40px',
                          position: 'absolute', // Position absolutely
                          left: '100%', // Place to the right of button
                          marginLeft: '8px', // Add some spacing
                        }}
                      />
                    )}
                  </Stack>
                </Stack>
                <Stack
                  alignItems={'center'}
                  sx={{
                    position: 'absolute',
                    bottom: '20px',
                    left: '48%',
                    display: matches700 && 'none',
                    pointerEvents: loadingSubmit ? 'none' : 'auto',
                    opacity: loadingSubmit ? 0.5 : 1,
                  }}
                >
                  <Typography
                    onClick={() => {
                      setRegister(!register);
                      setBuyerIdInput('');
                    }}
                    className="bottomicon"
                  >
                    <Category width={28} height={28} className="home" />
                  </Typography>
                  <Typography
                    onClick={() => {
                      setRegister(!register);
                      setBuyerIdInput('');
                    }}
                    sx={{
                      fontFamily: 'poppins',
                      fontSize: '14px',
                      color: '#9A9A9F',
                      lineHeight: '14px',
                      paddingTop: '5px',
                      cursor: 'pointer',
                    }}
                  >
                    Home
                  </Typography>
                </Stack>
              </>
            )}

            {checkInType == 'Form' &&
              (buyerClicked === true ? (
                <Box
                  sx={{
                    flex: 1,
                    overflowY: 'auto',
                    scrollbarWidth: 'none',
                    '&::-webkit-scrollbar': { display: 'none' },
                    paddingBottom: matchessm && '90px',
                  }}
                >
                  <form onSubmit={handleSubmit}>
                    <Typography
                      width={'100%'}
                      paddingTop={'3vh'}
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <TextField
                        variant="outlined"
                        sx={{
                          color: '#000000',
                          background: 'transparent',
                          borderRadius: '5px',
                          height: '7vh',
                          display: 'flex',
                          justifyContent: 'center',
                          paddingLeft: matchessm ? '0px' : '10px',
                          width: matchessm ? '80%' : '500px',
                          '.MuiFormHelperText-contained': {
                            margin: '0',
                            fontFamily: 'poppins',
                          },
                          '.MuiOutlinedInput-input': {
                            padding: matchessm ? '10px 14px' : '16px 14px',
                          },
                        }}
                        InputLabelProps={{ shrink: false }}
                        placeholder="First Name"
                        id="outlined-basic"
                        type="text"
                        name="name"
                        onFocus={(e) => {
                          setSurnameAnchorEl('');
                          setEmailAnchorEl('');
                          setMobileAnchorEl('');
                        }}
                        onChange={handleChange}
                        value={formValues.name.value}
                        error={formValues.name.error}
                        helperText={
                          formValues.name.error && formValues.name.errorMessage
                        }
                        inputProps={{
                          maxLength: 25,
                          style: {
                            fontFamily: 'poppins',
                            textTransform: 'capitalize',
                          },
                          onKeyPress: (event) => {
                            const charCode = event.which
                              ? event.which
                              : event.keyCode;
                            if (charCode >= 48 && charCode <= 57) {
                              event.preventDefault();
                            }
                          },
                        }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Typography
                                sx={{
                                  background: 'transparent',
                                  paddingRight: '10px',
                                  borderRight: '1px solid black',
                                  display: 'flex',
                                  alignItems: 'center',
                                }}
                              >
                                <Usericon />
                              </Typography>
                            </InputAdornment>
                          ),
                        }}
                        autoComplete="off"
                      />

                      {/* prefill suggestions */}
                      <Box
                        sx={{
                          position: 'relative',
                          display: 'block',
                        }}
                      >
                        {nameAnchorEl && (
                          <Box
                            sx={{
                              position: 'absolute',
                              top: '100%',
                              right: 0,
                              minWidth: matchessm ? '200px' : '330px',
                              maxHeight: '800px',
                              overflowY: 'auto',
                              overflowX: 'hidden',
                              boxShadow: 3,
                              marginTop: 4,

                              backgroundColor: '#fff',
                              zIndex: 1000,
                              display: 'flex',
                              flexDirection: 'column',
                            }}
                          >
                            {/* Scrollable list of users */}
                            <Box
                              sx={{
                                flexGrow: 1,
                                overflowY: 'scroll',
                                maxHeight: '250px',
                                paddingLeft: matchessm ? 1 : 2,
                                paddingTop: matchessm ? 1 : 2,
                                scrollbarWidth: 'thin !important',
                                '&:hover': {
                                  overflowY: 'scroll',
                                },
                                '&::-webkit-scrollbar': {
                                  display: 'block !important',
                                  scrollbarWidth: 'thin !important',
                                },
                                '&::-webkit-scrollbar-track': {
                                  backgroundColor: '#f1f1f1',
                                },
                                '&::-webkit-scrollbar-thumb': {
                                  backgroundColor: '#888 !important',
                                },
                                '&::-webkit-scrollbar-thumb:hover': {
                                  backgroundColor: '#555 !important',
                                },
                              }}
                            >
                              {checkInSuggestion &&
                              Array.isArray(checkInSuggestion?.userData) &&
                              checkInSuggestion?.userData.length > 0 ? (
                                <>
                                  {checkInSuggestion.userData.map(
                                    (dataItem, i) => (
                                      <Box
                                        key={i}
                                        sx={{
                                          display: 'flex',
                                          flexDirection: 'column',
                                          marginBottom: 1,
                                          padding: 1,
                                          cursor: 'pointer',
                                          borderRadius: '10px',
                                          backgroundColor: '#f9f9f9',
                                        }}
                                        onClick={() =>
                                          handleSuggestionClick(dataItem)
                                        }
                                      >
                                        {dataItem?.userInspectedDates?.length >
                                          0 &&
                                          !checkInErrorData && (
                                            <Grid
                                              sx={{
                                                marginBottom: '10px',
                                                display: 'flex',
                                                flexDirection: 'column',
                                                gap: 1,
                                                border: '1px solid #F39800',
                                                padding: '10px 5px',
                                                borderRadius: '5px',
                                                backgroundColor: '#FFF7E9',
                                              }}
                                            >
                                              <Typography
                                                sx={{
                                                  ...poppins600,
                                                  fontSize: '12px',
                                                  color: '#F39800',
                                                }}
                                              >
                                                This buyer has already
                                                inspected.
                                              </Typography>

                                              <List sx={{ paddingTop: 0 }}>
                                                <Typography
                                                  sx={{
                                                    ...poppins400,
                                                    color: '#F39800',
                                                    fontSize: '12px',
                                                  }}
                                                >
                                                  Past Inspections:
                                                </Typography>
                                                {dataItem?.userInspectedDates?.map(
                                                  (date) => {
                                                    return (
                                                      <ListItem
                                                        sx={{
                                                          py: 0,
                                                          ...poppins400,
                                                          color: '#F39800',
                                                          fontSize: '12px',
                                                          px: 1,
                                                        }}
                                                        disableGutters
                                                      >
                                                        <ListItemText
                                                          primary={`• ${date}`}
                                                          primaryTypographyProps={{
                                                            ...poppins400,
                                                            color: '#F39800',
                                                            fontSize: '12px',
                                                          }}
                                                        />
                                                      </ListItem>
                                                    );
                                                  }
                                                )}
                                              </List>
                                            </Grid>
                                          )}
                                        <Typography
                                          sx={{
                                            fontFamily: 'poppins',
                                            fontWeight: 500,
                                            fontSize: '14px',
                                            color: '#666',
                                          }}
                                        >
                                          {`${dataItem.userName} ${dataItem.userSurName}`}
                                        </Typography>
                                        <Typography
                                          sx={{
                                            fontFamily: 'poppins',
                                            fontSize: '12px',
                                            color: '#999',
                                          }}
                                        >
                                          {dataItem.userEmail}
                                        </Typography>
                                      </Box>
                                    )
                                  )}
                                </>
                              ) : (
                                <Typography
                                  sx={{
                                    fontFamily: 'poppins',
                                    fontSize: '14px',
                                    color: 'black',
                                  }}
                                >
                                  No existing contact available
                                </Typography>
                              )}
                            </Box>
                            <Divider />
                            {/* Fixed "Add this as new contact" section */}
                            <Box
                              sx={{
                                paddingTop: 1,
                                paddingBottom: 1,
                                textAlign: 'center',
                              }}
                              onClick={() => {
                                setNameAnchorEl('');
                              }}
                            >
                              <Typography
                                sx={{
                                  fontFamily: 'poppins',
                                  fontSize: '14px',
                                  color: '#007BFF',
                                  cursor: 'pointer',
                                }}
                              >
                                {`+ Add this '${formValues.name.value}' as new contact`}
                              </Typography>
                            </Box>
                          </Box>
                        )}
                      </Box>
                    </Typography>

                    <Typography
                      width={'100%'}
                      paddingTop={'3vh'}
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <TextField
                        variant="outlined"
                        sx={{
                          color: '#000000',
                          background: 'transparent',
                          borderRadius: '5px',
                          height: '7vh',
                          display: 'flex',
                          justifyContent: 'center',
                          paddingLeft: matchessm ? '0px' : '10px',
                          width: matchessm ? '80%' : '500px',
                          '.MuiFormHelperText-contained': {
                            margin: '0',
                            fontFamily: 'poppins',
                          },
                          '.MuiOutlinedInput-input': {
                            padding: matchessm ? '10px 14px' : '16px 14px',
                          },
                        }}
                        InputLabelProps={{ shrink: false }}
                        placeholder="Last Name"
                        id="outlined-basic"
                        type="text"
                        name="surname"
                        onFocus={(e) => {
                          setNameAnchorEl('');
                          setEmailAnchorEl('');
                          setMobileAnchorEl('');
                        }}
                        onChange={handleChange}
                        value={formValues.surname.value}
                        error={formValues.surname.error}
                        helperText={
                          formValues.surname.error &&
                          formValues.surname.errorMessage
                        }
                        inputProps={{
                          maxLength: 25,
                          style: {
                            fontFamily: 'poppins',
                            textTransform: 'capitalize',
                          },
                          onKeyPress: (event) => {
                            const charCode = event.which
                              ? event.which
                              : event.keyCode;
                            if (charCode >= 48 && charCode <= 57) {
                              event.preventDefault();
                            }
                          },
                        }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Typography
                                sx={{
                                  background: 'transparent',
                                  paddingRight: '10px',
                                  borderRight: '1px solid black',
                                  display: 'flex',
                                  alignItems: 'center',
                                }}
                              >
                                <Usericon />
                              </Typography>
                            </InputAdornment>
                          ),
                        }}
                        autoComplete="off"
                      />

                      {/* prefillsuggestion for surname */}
                      <Box
                        sx={{
                          position: 'relative',
                          display: 'block',
                        }}
                      >
                        {surnameAnchorEl && (
                          <Box
                            sx={{
                              position: 'absolute',
                              top: '100%',
                              right: 0,
                              minWidth: matchessm ? '200px' : '330px',
                              maxHeight: '800px',
                              overflowY: 'auto',
                              overflowX: 'hidden',
                              boxShadow: 3,
                              marginTop: 4,

                              backgroundColor: '#fff',
                              zIndex: 1000,
                              display: 'flex',
                              flexDirection: 'column',
                            }}
                          >
                            {/* Scrollable list of users */}
                            <Box
                              sx={{
                                flexGrow: 1,
                                overflowY: 'scroll',
                                maxHeight: '250px',
                                paddingLeft: matchessm ? 1 : 2,
                                paddingTop: matchessm ? 1 : 2,
                                scrollbarWidth: 'thin !important',
                                '&:hover': {
                                  overflowY: 'scroll',
                                },
                                '&::-webkit-scrollbar': {
                                  display: 'block !important',
                                  scrollbarWidth: 'thin !important',
                                },
                                '&::-webkit-scrollbar-track': {
                                  backgroundColor: '#f1f1f1',
                                },
                                '&::-webkit-scrollbar-thumb': {
                                  backgroundColor: '#888 !important',
                                },
                                '&::-webkit-scrollbar-thumb:hover': {
                                  backgroundColor: '#555 !important',
                                },
                              }}
                            >
                              {checkInSuggestion &&
                              Array.isArray(checkInSuggestion?.userData) &&
                              checkInSuggestion?.userData.length > 0 ? (
                                <>
                                  {checkInSuggestion.userData.map(
                                    (dataItem, i) => (
                                      <Box
                                        key={i}
                                        sx={{
                                          display: 'flex',
                                          flexDirection: 'column',
                                          marginBottom: 1,
                                          padding: 1,
                                          cursor: 'pointer',
                                          borderRadius: '10px',
                                          backgroundColor: '#f9f9f9',
                                        }}
                                        onClick={() =>
                                          handleSuggestionClick(dataItem)
                                        }
                                      >
                                        {dataItem?.userInspectedDates?.length >
                                          0 &&
                                          !checkInErrorData && (
                                            <Grid
                                              sx={{
                                                marginBottom: '10px',
                                                display: 'flex',
                                                flexDirection: 'column',
                                                gap: 1,
                                                border: '1px solid #F39800',
                                                padding: '10px 5px',
                                                borderRadius: '5px',
                                                backgroundColor: '#FFF7E9',
                                              }}
                                            >
                                              <Typography
                                                sx={{
                                                  ...poppins600,
                                                  fontSize: '12px',
                                                  color: '#F39800',
                                                }}
                                              >
                                                This buyer has already
                                                inspected.
                                              </Typography>

                                              <List sx={{ paddingTop: 0 }}>
                                                <Typography
                                                  sx={{
                                                    ...poppins400,
                                                    color: '#F39800',
                                                    fontSize: '12px',
                                                  }}
                                                >
                                                  Past Inspections:
                                                </Typography>
                                                {dataItem?.userInspectedDates?.map(
                                                  (date) => {
                                                    return (
                                                      <ListItem
                                                        sx={{
                                                          py: 0,
                                                          ...poppins400,
                                                          color: '#F39800',
                                                          fontSize: '12px',
                                                          px: 1,
                                                        }}
                                                        disableGutters
                                                      >
                                                        <ListItemText
                                                          primary={`• ${date}`}
                                                          primaryTypographyProps={{
                                                            ...poppins400,
                                                            color: '#F39800',
                                                            fontSize: '12px',
                                                          }}
                                                        />
                                                      </ListItem>
                                                    );
                                                  }
                                                )}
                                              </List>
                                            </Grid>
                                          )}
                                        <Typography
                                          sx={{
                                            fontFamily: 'poppins',
                                            fontWeight: 500,
                                            fontSize: '14px',
                                            color: '#666',
                                          }}
                                        >
                                          {`${dataItem.userName} ${dataItem.userSurName}`}
                                        </Typography>
                                        <Typography
                                          sx={{
                                            fontFamily: 'poppins',
                                            fontSize: '12px',
                                            color: '#999',
                                          }}
                                        >
                                          {dataItem.userEmail}
                                        </Typography>
                                      </Box>
                                    )
                                  )}
                                </>
                              ) : (
                                <Typography
                                  sx={{
                                    fontFamily: 'poppins',
                                    fontSize: '14px',
                                    color: 'black',
                                  }}
                                >
                                  No existing contact available
                                </Typography>
                              )}
                            </Box>
                            <Divider />
                            {/* Fixed "Add this as new contact" section */}
                            <Box
                              sx={{
                                paddingTop: 1,
                                paddingBottom: 1,
                                textAlign: 'center',
                              }}
                              onClick={() => {
                                setSurnameAnchorEl('');
                              }}
                            >
                              <Typography
                                sx={{
                                  fontFamily: 'poppins',
                                  fontSize: '14px',
                                  color: '#007BFF',
                                  cursor: 'pointer',
                                }}
                              >
                                {`+ Add this '${formValues.surname.value}' as new contact`}
                              </Typography>
                            </Box>
                          </Box>
                        )}
                      </Box>
                    </Typography>

                    <Typography
                      paddingTop={'3vh'}
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <TextField
                        variant="outlined"
                        sx={{
                          color: '#000000',
                          background: 'transparent',
                          borderRadius: '5px',
                          height: '7vh',
                          display: 'flex',
                          justifyContent: 'center',
                          paddingLeft: matchessm ? '0px' : '10px',
                          width: matchessm ? '80%' : '500px',
                          '.MuiFormHelperText-contained': {
                            margin: '0',
                            fontFamily: 'poppins',
                          },
                          '.MuiOutlinedInput-input': {
                            padding: matchessm ? '10px 14px' : '16px 14px',
                          },
                        }}
                        placeholder="Email"
                        id="userEmail"
                        name="userEmail"
                        type="text"
                        onKeyDown={(e) => {
                          if (e.key === ' ') {
                            e.preventDefault();
                          }
                        }}
                        onChange={handleChange}
                        onFocus={(e) => {
                          setNameAnchorEl('');
                          setSurnameAnchorEl('');
                          setMobileAnchorEl('');
                        }}
                        value={formValues.userEmail.value}
                        error={formValues.userEmail.error}
                        helperText={
                          formValues.userEmail.error &&
                          formValues.userEmail.errorMessage
                        }
                        InputLabelProps={{ shrink: false }}
                        inputProps={{
                          style: {
                            fontFamily: 'poppins',
                            textTransform: 'none',
                          },
                        }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <img
                                alt="img"
                                src={mailicon}
                                style={{
                                  background: 'transparent',
                                  paddingRight: '10px',
                                  borderRight: '1px solid black',
                                }}
                              />
                            </InputAdornment>
                          ),
                        }}
                        autoComplete="off"
                      />
                      {/* prefillsuggestion for email */}
                      <Box
                        sx={{
                          position: 'relative',
                          display: 'block',
                        }}
                      >
                        {emailAnchorEl && (
                          <Box
                            sx={{
                              position: 'absolute',
                              bottom: '100%',
                              right: 0,
                              minWidth: matchessm ? '200px' : '330px',
                              maxHeight: '800px',
                              overflowY: 'auto',
                              overflowX: 'hidden',
                              boxShadow: 3,
                              marginBottom: -4,

                              backgroundColor: '#fff',
                              zIndex: 1000,
                              display: 'flex',
                              flexDirection: 'column',
                            }}
                          >
                            {/* Scrollable list of users */}
                            <Box
                              sx={{
                                flexGrow: 1,
                                overflowY: 'scroll',
                                maxHeight: '250px',
                                paddingLeft: matchessm ? 1 : 2,
                                paddingTop: matchessm ? 1 : 2,
                                scrollbarWidth: 'thin !important',
                                '&:hover': {
                                  overflowY: 'scroll',
                                },
                                '&::-webkit-scrollbar': {
                                  display: 'block !important',
                                  scrollbarWidth: 'thin !important',
                                },
                                '&::-webkit-scrollbar-track': {
                                  backgroundColor: '#f1f1f1',
                                },
                                '&::-webkit-scrollbar-thumb': {
                                  backgroundColor: '#888 !important',
                                },
                                '&::-webkit-scrollbar-thumb:hover': {
                                  backgroundColor: '#555 !important',
                                },
                              }}
                            >
                              {checkInSuggestion &&
                              Array.isArray(checkInSuggestion?.userData) &&
                              checkInSuggestion?.userData.length > 0 ? (
                                <>
                                  {checkInSuggestion.userData.map(
                                    (dataItem, i) => (
                                      <Box
                                        key={i}
                                        sx={{
                                          display: 'flex',
                                          flexDirection: 'column',
                                          marginBottom: 1,
                                          padding: 1,
                                          cursor: 'pointer',
                                          borderRadius: '10px',
                                          backgroundColor: '#f9f9f9',
                                        }}
                                        onClick={() =>
                                          handleSuggestionClick(dataItem)
                                        }
                                      >
                                        {dataItem?.userInspectedDates?.length >
                                          0 &&
                                          !checkInErrorData && (
                                            <Grid
                                              sx={{
                                                marginBottom: '10px',
                                                display: 'flex',
                                                flexDirection: 'column',
                                                gap: 1,
                                                border: '1px solid #F39800',
                                                padding: '10px 5px',
                                                borderRadius: '5px',
                                                backgroundColor: '#FFF7E9',
                                              }}
                                            >
                                              <Typography
                                                sx={{
                                                  ...poppins600,
                                                  fontSize: '12px',
                                                  color: '#F39800',
                                                }}
                                              >
                                                This buyer has already
                                                inspected.
                                              </Typography>

                                              <List sx={{ paddingTop: 0 }}>
                                                <Typography
                                                  sx={{
                                                    ...poppins400,
                                                    color: '#F39800',
                                                    fontSize: '12px',
                                                  }}
                                                >
                                                  Past Inspections:
                                                </Typography>
                                                {dataItem?.userInspectedDates?.map(
                                                  (date) => {
                                                    return (
                                                      <ListItem
                                                        sx={{
                                                          py: 0,
                                                          ...poppins400,
                                                          color: '#F39800',
                                                          fontSize: '12px',
                                                          px: 1,
                                                        }}
                                                        disableGutters
                                                      >
                                                        <ListItemText
                                                          primary={`• ${date}`}
                                                          primaryTypographyProps={{
                                                            ...poppins400,
                                                            color: '#F39800',
                                                            fontSize: '12px',
                                                          }}
                                                        />
                                                      </ListItem>
                                                    );
                                                  }
                                                )}
                                              </List>
                                            </Grid>
                                          )}
                                        <Typography
                                          sx={{
                                            fontFamily: 'poppins',
                                            fontWeight: 500,
                                            fontSize: '14px',
                                            color: '#666',
                                          }}
                                        >
                                          {`${dataItem.userName} ${dataItem.userSurName}`}
                                        </Typography>
                                        <Typography
                                          sx={{
                                            fontFamily: 'poppins',
                                            fontSize: '12px',
                                            color: '#999',
                                          }}
                                        >
                                          {dataItem.userEmail}
                                        </Typography>
                                      </Box>
                                    )
                                  )}
                                </>
                              ) : (
                                <Typography
                                  sx={{
                                    fontFamily: 'poppins',
                                    fontSize: '14px',
                                    color: 'black',
                                  }}
                                >
                                  No existing contact available
                                </Typography>
                              )}
                            </Box>
                            <Divider />
                            {/* Fixed "Add this as new contact" section */}
                            <Box
                              sx={{
                                paddingTop: 1,
                                paddingBottom: 1,
                                textAlign: 'center',
                              }}
                              onClick={() => {
                                setEmailAnchorEl('');
                              }}
                            >
                              <Typography
                                sx={{
                                  fontFamily: 'poppins',
                                  fontSize: '14px',
                                  color: '#007BFF',
                                  cursor: 'pointer',
                                }}
                              >
                                {`+ Add this '${formValues.userEmail.value}' as new contact`}
                              </Typography>
                            </Box>
                          </Box>
                        )}
                      </Box>
                    </Typography>

                    <Typography
                      paddingTop={'3vh'}
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <TextField
                        sx={{
                          color: '#000000',
                          background: 'transparent',
                          borderRadius: '5px',
                          height: '7vh',
                          display: 'flex',
                          justifyContent: 'center',
                          paddingLeft: matchessm ? '0px' : '10px',
                          width: matchessm ? '80%' : '500px',
                          '& input[type=number]': {
                            '-moz-appearance': 'textfield',
                          },
                          '& input[type=number]::-webkit-outer-spin-button': {
                            '-webkit-appearance': 'none',
                            margin: 0,
                          },
                          '& input[type=number]::-webkit-inner-spin-button': {
                            '-webkit-appearance': 'none',
                            margin: 0,
                          },
                          '.MuiFormHelperText-contained': {
                            margin: '0',
                            fontFamily: 'poppins',
                          },
                          '.MuiOutlinedInput-input': {
                            padding: matchessm ? '10px 14px' : '16px 14px',
                          },
                        }}
                        inputProps={{
                          maxLength: 12,
                          style: { fontFamily: 'poppins' },
                        }}
                        placeholder="Mobile"
                        id="userPhoneNo"
                        name="userPhoneNo"
                        value={formValues.userPhoneNo.value}
                        error={formValues.userPhoneNo.error}
                        onFocus={(e) => {
                          setNameAnchorEl('');
                          setSurnameAnchorEl('');
                          setEmailAnchorEl('');
                        }}
                        onChange={handleChange}
                        helperText={
                          formValues.userPhoneNo.error &&
                          formValues.userPhoneNo.errorMessage
                        }
                        fullWidth
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Typography
                                sx={{
                                  background: 'transparent',
                                  paddingRight: '10px',
                                  borderRight: '1px solid black',
                                  display: 'flex',
                                  alignItems: 'center',
                                }}
                              >
                                <Mobile />
                              </Typography>
                            </InputAdornment>
                          ),
                        }}
                        autoComplete="off"
                      />

                      {/* prefillsuggestion for mobile */}
                      <Box
                        sx={{
                          position: 'relative',
                          display: 'block',
                        }}
                      >
                        {mobileAnchorEl && (
                          <Box
                            sx={{
                              position: 'absolute',
                              bottom: '100%',
                              right: 0,
                              minWidth: matchessm ? '200px' : '330px',
                              maxHeight: '800px',
                              overflowY: 'auto',
                              overflowX: 'hidden',
                              boxShadow: 3,
                              marginBottom: 4,

                              backgroundColor: '#fff',
                              zIndex: 1000,
                              display: 'flex',
                              flexDirection: 'column',
                            }}
                          >
                            {/* Scrollable list of users */}
                            <Box
                              sx={{
                                flexGrow: 1,
                                overflowY: 'scroll',
                                maxHeight: '250px',
                                paddingLeft: matchessm ? 1 : 2,
                                paddingTop: matchessm ? 1 : 2,
                                scrollbarWidth: 'thin !important',
                                '&:hover': {
                                  overflowY: 'scroll',
                                },
                                '&::-webkit-scrollbar': {
                                  display: 'block !important',
                                  scrollbarWidth: 'thin !important',
                                },
                                '&::-webkit-scrollbar-track': {
                                  backgroundColor: '#f1f1f1',
                                },
                                '&::-webkit-scrollbar-thumb': {
                                  backgroundColor: '#888 !important',
                                },
                                '&::-webkit-scrollbar-thumb:hover': {
                                  backgroundColor: '#555 !important',
                                },
                              }}
                            >
                              {checkInSuggestion &&
                              Array.isArray(checkInSuggestion?.userData) &&
                              checkInSuggestion?.userData.length > 0 ? (
                                <>
                                  {checkInSuggestion.userData.map(
                                    (dataItem, i) => (
                                      <Box
                                        key={i}
                                        sx={{
                                          display: 'flex',
                                          flexDirection: 'column',
                                          marginBottom: 1,
                                          padding: 1,
                                          cursor: 'pointer',
                                          borderRadius: '10px',
                                          backgroundColor: '#f9f9f9',
                                        }}
                                        onClick={() =>
                                          handleSuggestionClick(dataItem)
                                        }
                                      >
                                        {dataItem?.userInspectedDates?.length >
                                          0 &&
                                          !checkInErrorData && (
                                            <Grid
                                              sx={{
                                                marginBottom: '10px',
                                                display: 'flex',
                                                flexDirection: 'column',
                                                gap: 1,
                                                border: '1px solid #F39800',
                                                padding: '10px 5px',
                                                borderRadius: '5px',
                                                backgroundColor: '#FFF7E9',
                                              }}
                                            >
                                              <Typography
                                                sx={{
                                                  ...poppins600,
                                                  fontSize: '12px',
                                                  color: '#F39800',
                                                }}
                                              >
                                                This buyer has already
                                                inspected.
                                              </Typography>

                                              <List sx={{ paddingTop: 0 }}>
                                                <Typography
                                                  sx={{
                                                    ...poppins400,
                                                    color: '#F39800',
                                                    fontSize: '12px',
                                                  }}
                                                >
                                                  Past Inspections:
                                                </Typography>
                                                {dataItem?.userInspectedDates?.map(
                                                  (date) => {
                                                    return (
                                                      <ListItem
                                                        sx={{
                                                          py: 0,
                                                          ...poppins400,
                                                          color: '#F39800',
                                                          fontSize: '12px',
                                                          px: 1,
                                                        }}
                                                        disableGutters
                                                      >
                                                        <ListItemText
                                                          primary={`• ${date}`}
                                                          primaryTypographyProps={{
                                                            ...poppins400,
                                                            color: '#F39800',
                                                            fontSize: '12px',
                                                          }}
                                                        />
                                                      </ListItem>
                                                    );
                                                  }
                                                )}
                                              </List>
                                            </Grid>
                                          )}
                                        <Typography
                                          sx={{
                                            fontFamily: 'poppins',
                                            fontWeight: 500,
                                            fontSize: '14px',
                                            color: '#666',
                                          }}
                                        >
                                          {`${dataItem.userName} ${dataItem.userSurName}`}
                                        </Typography>
                                        <Typography
                                          sx={{
                                            fontFamily: 'poppins',
                                            fontSize: '12px',
                                            color: '#999',
                                          }}
                                        >
                                          {dataItem.userEmail}
                                        </Typography>
                                      </Box>
                                    )
                                  )}
                                </>
                              ) : (
                                <Typography
                                  sx={{
                                    fontFamily: 'poppins',
                                    fontSize: '14px',
                                    color: 'black',
                                  }}
                                >
                                  No existing contact available
                                </Typography>
                              )}
                            </Box>
                            <Divider />
                            {/* Fixed "Add this as new contact" section */}
                            <Box
                              sx={{
                                paddingTop: 1,
                                paddingBottom: 1,
                                textAlign: 'center',
                              }}
                              onClick={() => {
                                setMobileAnchorEl('');
                              }}
                            >
                              <Typography
                                sx={{
                                  fontFamily: 'poppins',
                                  fontSize: '14px',
                                  color: '#007BFF',
                                  cursor: 'pointer',
                                }}
                              >
                                {`+ Add this '${formValues.userPhoneNo.value}' as new contact`}
                              </Typography>
                            </Box>
                          </Box>
                        )}
                      </Box>
                    </Typography>

                    <Typography
                      sx={{
                        display: 'flex',
                        alignItems: 'end',
                        flexDirection: 'column',
                        paddingTop: '3vh',
                        margin: 'auto',
                        maxWidth: matchessm ? '80%' : '500px',
                      }}
                    >
                      <Typography
                        onClick={() => {
                          setNameAnchorEl('');
                          setSurnameAnchorEl('');
                          setEmailAnchorEl('');
                          setMobileAnchorEl('');
                          DisableClickNewBuyer();
                        }}
                        sx={{
                          color: '#5eadda',
                          fontFamily: 'poppins',
                          fontSize: matchessm ? '12px' : '16px',
                          cursor: 'pointer',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        + Add Existing Buyer
                      </Typography>
                      <Typography
                        display={'flex'}
                        justifyContent={'center'}
                        paddingTop={'3vh'}
                        sx={{
                          width: matchessm ? '100%' : 'auto',
                        }}
                      >
                        <Stack
                          direction={'row'}
                          justifyContent={'space-between'}
                          width={matchessm ? '100%' : '500px'}
                          alignItems={'center'}
                        >
                          <Stack
                            alignItems={'center'}
                            onClick={() => {
                              setNameAnchorEl('');
                              setSurnameAnchorEl('');
                              setEmailAnchorEl('');
                              setMobileAnchorEl('');
                              setRegister(!register);
                              setBuyerClicked(false);
                            }}
                            sx={{
                              pointerEvents: loading ? 'none' : 'auto',
                              opacity: loading ? 0.5 : 1,
                            }}
                          >
                            <Typography
                              onClick={() => {
                                setNameAnchorEl('');
                                setSurnameAnchorEl('');
                                setEmailAnchorEl('');
                                setMobileAnchorEl('');
                                setRegister(!register);
                                setBuyerClicked(false);
                              }}
                              className="bottomicon"
                            >
                              <Category
                                width={28}
                                height={28}
                                className="home"
                              />
                            </Typography>
                            <Typography
                              onClick={() => {
                                setNameAnchorEl('');
                                setSurnameAnchorEl('');
                                setEmailAnchorEl('');
                                setMobileAnchorEl('');
                                setRegister(!register);
                                setBuyerClicked(false);
                              }}
                              sx={{
                                fontFamily: 'poppins',
                                fontSize: '14px',
                                color: '#9A9A9F',
                                lineHeight: '14px',
                                paddingTop: '5px',
                              }}
                            >
                              Home
                            </Typography>
                          </Stack>
                          <div
                            style={{
                              position: 'relative',
                              display: 'flex',
                              alignItems: 'center',
                            }}
                          >
                            <Button
                              type="submit"
                              component={IconButton}
                              disabled={loading || formValues.userEmail.error}
                              onClick={() => {
                                handlefirstset();
                                setCheckInIndex('0');
                                setNameAnchorEl('');
                                setSurnameAnchorEl('');
                                setEmailAnchorEl('');
                                setMobileAnchorEl('');
                              }}
                              style={buttonStyles}
                            >
                              Check In
                            </Button>
                            {loading && (
                              <img
                                alt="Logo"
                                src={Loading}
                                className="loaderImage"
                                style={{ height: '40px', width: '40px' }}
                              />
                            )}
                          </div>
                        </Stack>
                      </Typography>
                    </Typography>
                  </form>
                </Box>
              ) : (
                <>
                  <Grid
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexDirection: 'column',
                      marginTop: '30px',
                      position: 'relative',
                    }}
                  >
                    <Grid
                      component="form"
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        backgroundColor: '#F8F8F8',
                        border: '1px solid #F0F0F0',
                        borderRadius: '30px',
                        height: '41px',
                        width: matchessm ? '90%' : matcheslg ? '50%' : '500px',
                      }}
                    >
                      <IconButton
                        disabled
                        sx={{ paddingLeft: '20px' }}
                        aria-label="search"
                      >
                        <img alt="searchIcon" src={searchIcon} />
                      </IconButton>
                      <InputBase
                        autoFocus
                        sx={{
                          flex: 1,
                          '& ::placeholder': {
                            color: '#66666  !important',
                            fontSize: '14px',
                            fontWeight: 400,
                            fontFamily: 'poppins',
                            opacity: 0.9,
                          },

                          fontSize: '14px',
                          fontWeight: 400,
                          fontFamily: 'poppins',
                        }}
                        placeholder="Search Email or Mobile"
                        inputProps={{
                          'aria-label': 'Search Email or Mobile',
                        }}
                        value={anchorEl}
                        onChange={handleInputChangeBuyercheckin}
                        disabled={loading}
                      />
                    </Grid>

                    {anchorEl && (
                      <BuyerCheckInCard
                        checkInData={checkInData}
                        checkInErrorData={checkInErrorData}
                        setAnchorEl={setAnchorEl}
                        clickNewBuyer={clickNewUser}
                        tooManyResults={tooManyResults}
                        activeIndex={activeIndex}
                        setCheckInIndex={setCheckInIndex}
                        loading={loading}
                        setLoading={setLoading}
                        propertyid={propertyid}
                        agencyId={agencyId}
                        getListInfo={getListInfo}
                        activityfun={activityfun}
                        register={register}
                        setRegister={setRegister}
                        checkin={checkin}
                        setCheckin={setCheckin}
                        setSearchCheckInUser={setSearchCheckInUser}
                        buyerSearchLoader={buyerSearchLoader}
                        setLoadingSubmit={setLoadingSubmit}
                      />
                    )}
                    <Grid
                      sx={{
                        marginLeft: matchessm ? '63%' : '17%',
                        marginTop: '40px',
                      }}
                    >
                      <Typography
                        onClick={() => {
                          clickNewBuyer();
                          setAnchorEl('');
                        }}
                        sx={{
                          color: '#5eadda',
                          fontFamily: 'poppins',
                          fontSize: matchessm ? '12px' : '16px',
                          cursor: 'pointer',
                        }}
                      >
                        + Add New Buyer
                      </Typography>
                    </Grid>
                  </Grid>
                  <Stack
                    alignItems={'center'}
                    sx={{
                      position: 'absolute',
                      bottom: '20px',
                      left: '48%',
                      display: matches700 && 'none',
                      pointerEvents: loadingSubmit || loading ? 'none' : 'auto',
                      opacity: loadingSubmit || loading ? 0.5 : 1,
                    }}
                  >
                    <Typography
                      onClick={() => {
                        setAnchorEl('');
                        setRegister(!register);
                      }}
                      className="bottomicon"
                    >
                      <Category width={28} height={28} className="home" />
                    </Typography>
                    <Typography
                      onClick={() => {
                        setAnchorEl('');
                        setRegister(!register);
                      }}
                      sx={{
                        fontFamily: 'poppins',
                        fontSize: '14px',
                        color: '#9A9A9F',
                        lineHeight: '14px',
                        paddingTop: '5px',
                        cursor: 'pointer',
                      }}
                    >
                      Home
                    </Typography>
                  </Stack>
                </>
              ))}
          </>
        </ScaledDialogContent>
      </Dialog>

      <Dialog
        fullScreen
        open={checkin}
        container={() => document.getElementById('dialog-root')}
        onClose={() => setCheckin(!checkin)}
        PaperProps={{
          sx: {
            width: '100vw',
            height: '100vh',
            maxWidth: '100vw',
            maxHeight: '100vh',
            borderRadius: 0,
          },
        }}
      >
        <ScaledDialogContent>
          <>
            <Typography
              display={'flex'}
              justifyContent={'space-between'}
              padding={'5px 15px'}
              sx={{ backgroundColor: '#F9F9F9', alignItems: 'center' }}
            >
              <img
                src={dashboardLogo}
                alt="logo"
                onClick={() => history.push('/dashboard')}
                style={{ cursor: 'pointer' }}
              />
              <IconButton
                onClick={() => {
                  setCheckin(!checkin);
                  setBuyerIdInput('');
                  setRegister(false);
                  setCheckInIndex('0');
                }}
              >
                <CloseRoundedIcon style={{ fontSize: '2.3rem' }} />
              </IconButton>
            </Typography>
            <Typography
              display="flex"
              alignItems="center"
              justifyContent={'center'}
              sx={{
                fontSize: matches700 ? '14px' : '20px',
                fontFamily: 'Poppins',
                fontWeight: 400,
                lineHeight: '30px',
                overflow: 'hidden',
                paddingTop: '2vh',
                textAlign: 'center',
                maxWidth: '100%',
              }}
            >
              <Location size={'32px'} />{' '}
              {
                props?.profileDetails?.PropertyDetails?.propertyAddress
                  ?.streetName
              }
            </Typography>
            <Typography
              display={'flex'}
              alignItems={'flex-start'}
              justifyContent={'center'}
              sx={{
                fontSize: '20px',
                fontFamily: 'poppins',
                fontWeight: 700,
                lineHeight: '30px',
                paddingTop: '2vh',
                textAlign: 'center',
              }}
            >
              Buyer Check-In
            </Typography>

            <Typography
              display={'flex'}
              alignItems={'flex-start'}
              justifyContent={'center'}
              textAlign={'center'}
              paddingTop={'1vh'}
            >
              <Success />
            </Typography>
            <Typography
              paddingTop={matchessm ? '2vh' : '5vh'}
              display={'flex'}
              alignItems={'flex-start'}
              justifyContent={'center'}
              sx={{
                fontFamily: 'poppins',
                fontSize: '20px',
                fontWeight: 700,
                color: '#6C2AD2',
                lineHeight: '30px',
              }}
            >
              Success
            </Typography>
            <Typography
              paddingTop={'5vh'}
              display={'flex'}
              justifyContent={'center'}
            >
              <Stack
                width={matchessm ? '80%' : '500px'}
                direction={'row'}
                alignItems={'center'}
              >
                <Typography width={'15%'}>
                  {' '}
                  <Usericon />
                </Typography>
                <Typography
                  width={'65%'}
                  sx={{
                    fontFamily: 'poppins',
                    fontSize: '16px',
                    color: '#9F9F9F',
                    fontWeight: 300,
                    lineHeight: '24px',
                    textTransform: 'capitalize',
                  }}
                >
                  {checkInIndex == '1'
                    ? `${searchCheckInUser?.userName || ''} ${
                        searchCheckInUser?.userSurName || ''
                      }`
                    : checkInIndex == '2'
                    ? `${checkInData?.userName} ${checkInData?.userSurName}`
                    : `${formValues?.name?.value} ${formValues?.surname?.value}`}
                </Typography>
                <Typography width={'20%'} textAlign={'right'}>
                  {' '}
                  <Tick />
                </Typography>
              </Stack>
            </Typography>
            <Typography
              paddingTop={'5vh'}
              display={'flex'}
              justifyContent={'center'}
            >
              <Stack
                width={matchessm ? '80%' : '500px'}
                direction={'row'}
                alignItems={'center'}
              >
                <Typography width={'15%'}>
                  {' '}
                  <img alt="img" src={mailicon} width={'28px'} />
                </Typography>
                <Tooltip
                  title={
                    checkInIndex == '1'
                      ? searchCheckInUser?.userEmail
                      : checkInIndex == '2'
                      ? checkInData?.userEmail
                      : formValues.userEmail.value
                  }
                  placement="bottom"
                  disableInteractive
                  componentsProps={{
                    tooltip: {
                      sx: {
                        bgcolor: '#fafafa',
                        boxShadow: '0px 2px 20px lightgray',
                        color: 'black',
                        padding: '10px',
                        fontFamily: 'poppins !important',
                        fontSize: '14px',
                        minWidth: 'min-content',
                      },
                    },
                  }}
                >
                  <Typography
                    width={'65%'}
                    sx={{
                      fontFamily: 'poppins',
                      fontSize: '16px',
                      color: '#9F9F9F',
                      fontWeight: 300,
                      lineHeight: '24px',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    }}
                  >
                    {checkInIndex == '1'
                      ? searchCheckInUser?.userEmail
                      : checkInIndex == '2'
                      ? checkInData?.userEmail
                      : formValues.userEmail.value}
                  </Typography>
                </Tooltip>
                <Typography width={'20%'} textAlign={'right'}>
                  {' '}
                  <Tick />
                </Typography>
              </Stack>
            </Typography>
            <Typography
              paddingTop={'5vh'}
              display={'flex'}
              justifyContent={'center'}
            >
              <Stack
                width={matchessm ? '80%' : '500px'}
                direction={'row'}
                alignItems={'center'}
              >
                <Typography width={'15%'}>
                  {' '}
                  <Mobile />
                </Typography>
                <Typography
                  width={'65%'}
                  sx={{
                    fontFamily: 'poppins',
                    fontSize: '16px',
                    color: '#9F9F9F',
                    fontWeight: 300,
                    lineHeight: '24px',
                  }}
                >
                  {checkInIndex == '1'
                    ? searchCheckInUser?.userPhone
                    : checkInIndex == '2'
                    ? checkInData?.userPhone
                    : formValues.userPhoneNo.value}
                </Typography>
                <Typography width={'20%'} textAlign={'right'}>
                  {' '}
                  <Tick />
                </Typography>
              </Stack>
            </Typography>

            <Typography
              display={'flex'}
              justifyContent={'center'}
              paddingTop={'1vh'}
              sx={{ position: 'absolute', bottom: '1vh', width: '100%' }}
            >
              <Stack
                direction={'row'}
                justifyContent={'space-between'}
                width={matchessm ? '80%' : '500px'}
                alignItems={'center'}
              >
                <Stack
                  alignItems={'center'}
                  component={IconButton}
                  onClick={() => {
                    setCheckin(!checkin);
                  }}
                >
                  <Typography
                    onClick={() => {
                      setCheckin(!checkin);
                      setRegister(false);
                      setCheckInIndex('0');
                    }}
                    className="bottomicon"
                  >
                    <Category width={28} height={28} className="home" />
                  </Typography>
                  <Typography
                    onClick={() => {
                      setCheckInIndex('0');
                      setRegister(false);
                    }}
                    sx={{
                      fontFamily: 'poppins',
                      fontSize: '14px',
                      color: '#9A9A9F',
                      lineHeight: '14px',
                      paddingTop: '5px',
                    }}
                  >
                    Home
                  </Typography>
                </Stack>
                <Typography
                  whiteSpace={'nowrap'}
                  component={IconButton}
                  onClick={() => {
                    setCheckin(!checkin);
                    setCheckInIndex('0');
                    setRegister(true);
                    setFormValues(formValuesempty);
                  }}
                  sx={{
                    fontSize: '12px',
                    fontFamily: 'poppins',
                    fontWeight: 400,
                    lineHeight: '18px',
                    backgroundColor: 'rgba(108, 42, 210, 0.1)',
                    height: '52px',
                    width: '140px',
                    borderRadius: '5px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    color: '#6C2AD2',
                  }}
                >
                  Add New Check In
                </Typography>
              </Stack>
            </Typography>
          </>
        </ScaledDialogContent>
      </Dialog>

      <Dialog
        fullScreen
        open={quickswitch}
        container={() => document.getElementById('dialog-root')}
        onClose={() => setQuickswitch(!quickswitch)}
        PaperProps={{
          sx: {
            width: '100vw',
            height: '100vh',
            maxWidth: '100vw',
            maxHeight: '100vh',
            borderRadius: 0,
          },
        }}
      >
        <ScaledDialogContent>
          <>
            <Typography
              display={'flex'}
              justifyContent={'space-between'}
              padding={'10px 15px'}
              sx={{ backgroundColor: '#F9F9F9' }}
            >
              <img
                src={dashboardLogo}
                alt="logo"
                onClick={() => history.push('/dashboard')}
                style={{ cursor: 'pointer' }}
              />
              <IconButton
                onClick={() => {
                  setQuickswitch(!quickswitch);
                }}
              >
                <CloseRoundedIcon style={{ fontSize: '2.3rem' }} />
              </IconButton>
            </Typography>
            <Typography
              display={'flex'}
              alignItems={'flex-start'}
              justifyContent={'center'}
              sx={{
                fontSize: '20px',
                fontFamily: 'poppins',
                fontWeight: 700,
                lineHeight: '30px',
                paddingTop: '1vh',
                textAlign: 'center',
              }}
            >
              Buyer Check-In
            </Typography>

            <Typography
              display={'flex'}
              alignItems={'center'}
              justifyContent={'center'}
              sx={{
                fontSize: matches700 ? '14px' : '20px',
                fontFamily: 'poppins',
                fontWeight: 400,
                paddingTop: '1vh',
                lineHeight: '30px',
              }}
            >
              <Location size={'32px'} />{' '}
              {
                props?.profileDetails?.PropertyDetails?.propertyAddress
                  ?.streetName
              }
              <IconButton
                onClick={() => {
                  setQuickswitch(!quickswitch);
                }}
              >
                {' '}
                {!quickswitch ? <Locationdown /> : <LocationUp />}
              </IconButton>
            </Typography>

            <Typography
              sx={{
                border: '1px solid #D9D9D9',
                borderRadius: '5px',
                backgroundColor: '#FAFAFA',
                height: '950vh',
              }}
            >
              <QuickSwitch
                isShown={quickswitch}
                setIsShown={setQuickswitch}
                buyerregister={true}
              />
              <Footerelements buyerCheckIn={true} />
            </Typography>
          </>
        </ScaledDialogContent>
      </Dialog>

      <Dialog
        open={filter}
        PaperProps={{
          sx: {
            borderRadius: '5px',
            boxShadow: 'none',
            padding: matchessm ? '10px' : '30px',
            minHeight: matchessm ? '95vh' : 'auto',
            minWidth: matchessm
              ? '95%'
              : matchesmd
              ? null
              : matcheslg
              ? '800px'
              : '1000px',
            border: '1px solid',
            borderImage:
              'linear-gradient(to right,#5FACDF, #6668DB, #C6A7D5) 1',
            backgroundColor: '#F8F8F8',
          },
        }}
      >
        <Stack spacing={3}>
          <Typography
            sx={{ fontFamily: 'poppins', fontSize: '16px', fontWeight: 500 }}
          >
            Buyer Readiness
          </Typography>
          <ToggleButtonGroup
            exclusive
            color="primary"
            value={selectedReadiness}
            onChange={handleReadiness}
            sx={{
              '.MuiToggleButtonGroup-grouped': {
                borderWidth: 0.5,
                borderColor: '#A1A7A8',
                fontFamily: 'poppins',
                minWidth: '8vw',
                height: '35px',
                '&:hover': {
                  borderColor: '#6C2AD2',
                },
                textTransform: 'capitalize',
              },
            }}
          >
            {readyArr.map((data) => {
              return (
                <ToggleButton
                  value={data?.label}
                  sx={{
                    borderRadius: matchessm ? '0px' : 'auto',
                    fontSize: matchessm ? '12px' : '14px',
                  }}
                >
                  {data.label} {data.label !== 'Any' && '+'}
                </ToggleButton>
              );
            })}
          </ToggleButtonGroup>
          <Typography
            sx={{ fontFamily: 'poppins', fontSize: '16px', fontWeight: 500 }}
          >
            Offer Price
          </Typography>
          <Stack
            direction={'row'}
            sx={{ width: '100%', justifyContent: 'center' }}
          >
            <Stack
              direction={'row'}
              spacing={1}
              sx={{
                display: 'flex',
                justifyContent: 'left',
                flexWrap: 'wrap',
                listStyle: 'none',
                p: 0.5,
                m: 0,
                width: matchessm ? '65%' : '85%',
              }}
            >
              <Box sx={{ position: 'relative', width: '100%' }}>
                <AirbnbSlider
                  value={slidervalue}
                  min={0}
                  max={60000000}
                  valueLabelDisplay="off"
                  onChange={handleChangeforslider}
                  slots={{ thumb: AirbnbThumbComponent }}
                />

                {slidervalue[0] === slidervalue[1] ? (
                  <Typography
                    sx={{
                      position: 'absolute',
                      top: 30,
                      left: `${(slidervalue[0] / 60000000) * 100}%`,
                      transform: 'translateX(-50%)',
                      whiteSpace: 'nowrap',
                      fontWeight: 500,
                      fontSize: 14,
                      fontFamily: 'Poppins',
                    }}
                  >
                    {valueLabelFormat(slidervalue[0])}
                  </Typography>
                ) : (
                  <>
                    <Typography
                      sx={{
                        position: 'absolute',
                        top: 30,
                        left: `${(slidervalue[0] / 60000000) * 100}%`,
                        transform: 'translateX(-100%)',
                        whiteSpace: 'nowrap',
                        fontWeight: 500,
                        fontSize: 14,
                        fontFamily: 'Poppins',
                      }}
                    >
                      {valueLabelFormat(slidervalue[0])}
                    </Typography>

                    <Typography
                      sx={{
                        position: 'absolute',
                        top: 30,
                        left: `${(slidervalue[1] / 60000000) * 100}%`,
                        transform: 'translateX(0)',
                        whiteSpace: 'nowrap',
                        fontWeight: 500,
                        fontSize: 14,
                        fontFamily: 'Poppins',
                      }}
                    >
                      {valueLabelFormat(slidervalue[1])}
                    </Typography>
                  </>
                )}
              </Box>
            </Stack>
          </Stack>

          <Typography
            sx={{ fontFamily: 'poppins', fontSize: '16px', fontWeight: 500 }}
          >
            s66W
          </Typography>
          <ToggleButtonGroup
            exclusive
            color="primary"
            value={selected66w}
            onChange={handle66w}
            sx={{
              '.MuiToggleButtonGroup-grouped': {
                borderWidth: 0.5,
                borderColor: '#A1A7A8',
                fontFamily: 'poppins',
                minWidth: '8vw',
                height: '35px',
                '&:hover': {
                  borderColor: '#6C2AD2',
                },
                textTransform: 'capitalize',
              },
            }}
          >
            <ToggleButton
              value={'Yes'}
              sx={{
                borderRadius: matchessm ? '0px' : 'auto',
                fontSize: matchessm ? '12px' : '14px',
              }}
            >
              Yes
            </ToggleButton>
            <ToggleButton
              value={'No'}
              sx={{
                borderRadius: matchessm ? '0px' : 'auto',
                fontSize: matchessm ? '12px' : '14px',
              }}
            >
              No
            </ToggleButton>
          </ToggleButtonGroup>
          <Typography
            sx={{ fontFamily: 'poppins', fontSize: '16px', fontWeight: 500 }}
          >
            Buyer Location
          </Typography>
          <ToggleButtonGroup
            exclusive
            color="primary"
            value={selectedBuyerLocation}
            onChange={handleBuyerLoaction}
            sx={{
              '.MuiToggleButtonGroup-grouped': {
                borderWidth: 0.5,
                borderColor: '#A1A7A8',
                fontFamily: 'poppins',
                minWidth: '8vw',
                height: '35px',
                '&:hover': {
                  borderColor: '#6C2AD2',
                },
                textTransform: 'capitalize',
              },
            }}
          >
            <ToggleButton
              value={'Local'}
              sx={{
                borderRadius: matchessm ? '0px' : 'auto',
                fontSize: matchessm ? '12px' : '14px',
              }}
            >
              Local
            </ToggleButton>
            <ToggleButton
              value={'Foreign'}
              sx={{
                borderRadius: matchessm ? '0px' : 'auto',
                fontSize: matchessm ? '12px' : '14px',
              }}
            >
              Foreign
            </ToggleButton>
          </ToggleButtonGroup>
          <Typography
            sx={{ fontFamily: 'poppins', fontSize: '16px', fontWeight: 500 }}
          >
            Profile
          </Typography>
          <ToggleButtonGroup
            exclusive
            color="primary"
            value={selectedProfile}
            onChange={handleProfile}
            sx={{
              display: 'grid',
              gridTemplateColumns: matchessm
                ? 'repeat(2, 1fr)'
                : 'repeat(auto-fit, minmax(8vw, 1fr))',
              '.MuiToggleButtonGroup-grouped': {
                borderWidth: 0.5,
                borderColor: '#A1A7A8',
                fontFamily: 'poppins',
                height: '35px',
                '&:hover': {
                  borderColor: '#6C2AD2',
                },
                textTransform: 'capitalize',
              },
              '.MuiToggleButtonGroup-middleButton': {
                marginLeft: matchessm ? '0px' : '-1px',
              },
              '.MuiToggleButtonGroup-lastButton': {
                marginLeft: matchessm ? '0px' : '-1px',
              },
            }}
          >
            {profileArr.map((data) => (
              <ToggleButton
                key={data.key}
                value={data.key}
                sx={{
                  borderRadius: matchessm ? '0px' : 'auto',
                  minWidth: '8vw',
                  maxWidth: '100%',
                  fontSize: matchessm ? '12px' : '14px',
                }}
              >
                {data.label}
              </ToggleButton>
            ))}
          </ToggleButtonGroup>

          <Typography
            sx={{ fontFamily: 'poppins', fontSize: '16px', fontWeight: 500 }}
          >
            No. of Offers
          </Typography>
          <ToggleButtonGroup
            exclusive
            color="primary"
            value={selectedNoOfOffer}
            onChange={handleNoOfOffer}
            sx={{
              '.MuiToggleButtonGroup-grouped': {
                borderWidth: 0.5,
                borderColor: '#A1A7A8',
                fontFamily: 'poppins',
                minWidth: '6.8vw',
                height: '35px',
                '&:hover': {
                  borderColor: '#6C2AD2',
                },
                textTransform: 'capitalize',
              },
            }}
          >
            {noOfOfferArr.map((data) => {
              return (
                <ToggleButton
                  value={data?.label}
                  sx={{
                    borderRadius: matchessm ? '0px' : 'auto',
                    fontSize: matchessm ? '12px' : '14px',
                  }}
                >
                  {data.label}
                  {data.label !== 'Any' && '+'}
                </ToggleButton>
              );
            })}
          </ToggleButtonGroup>

          <Typography
            sx={{ fontFamily: 'poppins', fontSize: '16px', fontWeight: 500 }}
          >
            Experience
          </Typography>
          <ToggleButtonGroup
            exclusive
            color="primary"
            value={selectedExperience}
            onChange={handleExperience}
            sx={{
              display: 'flex',
              flexWrap: 'wrap',
              '.MuiToggleButtonGroup-grouped': {
                borderWidth: 0.5,
                borderColor: '#A1A7A8',
                fontFamily: 'poppins',
                minWidth: '8vw',
                height: '35px',
                '&:hover': {
                  borderColor: '#6C2AD2',
                },
                textTransform: 'capitalize',
              },
              '@media (max-width: 600px)': {
                '.MuiToggleButtonGroup-grouped': {
                  flexBasis: '35%',
                  minWidth: 'unset',
                },
              },
              '.MuiToggleButtonGroup-middleButton': {
                marginLeft: matchessm ? '0px' : '-1px',
              },
              '.MuiToggleButtonGroup-lastButton': {
                marginLeft: matchessm ? '0px' : '-1px',
              },
            }}
          >
            {expArr.map((data) => {
              return (
                <ToggleButton
                  key={data?.label}
                  value={data?.label}
                  sx={{
                    borderRadius: matchessm ? '0px' : 'auto',
                    fontSize: matchessm ? '12px' : '14px',
                  }}
                >
                  {data.label !== 'Any' && 'Level '}
                  {data.label}
                </ToggleButton>
              );
            })}
          </ToggleButtonGroup>
        </Stack>
        <Stack
          direction={matchessm ? 'column' : 'row'}
          justifyContent={'right'}
          sx={{ marginTop: '20px' }}
          gap={matchessm ? 1 : 3}
        >
          <Button
            variant="outlined"
            style={{
              padding: '5px 30px',
              minWidth: '150px',
              height: matchessm ? '30px' : '50px',
              fontSize: matchessm ? '12px' : '14px',
              color: '#666666',
              fontWeight: '400',
              fontFamily: 'poppins',
              border: '1px solid rgba(17, 35, 71, 0.1)',
              borderRadius: '5px',
              textTransform: 'capitalize',
            }}
            onClick={() => setFilter(!filter)}
          >
            Cancel
          </Button>
          <Button
            variant="outlined"
            onClick={() => {
              setselectedReadiness([]);
              setselected66w([]);
              setselectedBuyerLocation([]);
              setselectedProfile([]);
              setselectedNoOfOffer([]);
              setselectedExperience([]);
              setSlidervalue([20000000, 30000000]);
              setMainFilter([...subFilter]);
            }}
            style={{
              padding: '5px 30px',
              height: matchessm ? '30px' : '50px',
              minWidth: '150px',
              fontSize: matchessm ? '12px' : '14px',
              color: '#666666',
              fontWeight: '400',
              fontFamily: 'poppins',
              border: '1px solid rgba(17, 35, 71, 0.1)',
              borderRadius: '5px',
              textTransform: 'capitalize',
            }}
          >
            Clear All
          </Button>
          <Button
            variant="outlined"
            onClick={() => filterResults()}
            style={{
              padding: '5px 30px',
              minWidth: '150px',
              fontSize: matchessm ? '12px' : '14px',
              color: '#FFFFFF',
              height: matchessm ? '30px' : '50px',
              fontWeight: '400',
              fontFamily: 'poppins',
              background: '#4CA4D6',
              borderRadius: '5px',
              cursor: 'pointer',
              textTransform: 'capitalize',
            }}
          >
            Show Result
          </Button>
        </Stack>
      </Dialog>
    </Card>
  );
}

BuyerRegistration.propTypes = {};

export default BuyerRegistration;
